import CommonService from '@/_core/service/commonService';
import appSettings from '@/plugins/appSettings';
import store from '@/store';
import urlObj from '@/../_config/_app/apiConfiguration.json';
import router from '@/router';
import moment from 'moment';

const reviewInformationDataMixin = {
  methods: {
    decodeHtmlEntities(str) {
      if (!str) return str;
      const el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    },
    async handleChange($event, arg, nestedValue, arg1, arg2) {
      if (arg1 === 'primaryCountry') {
        await this.statesloader($event);
        const country = this.reviewCountry.find((item) => item.codeReference === $event);

        if (this.tab === 0) {
          this.formData.primaryCountryDescription = country ? country.codeDescription : '';
          this.formData.primaryStateDescription = '';
        } else if (this.tab === 1) {
          this.secondaryFormData.primaryCountryDescription = country ? country.codeDescription : '';
          this.secondaryFormData.primaryStateDescription = '';
        }
      } else if (arg1 === 'correspondingCountry') {
        await this.corrstatesloader($event);
        const country = this.reviewCountry.find((item) => item.codeReference === $event);

        if (this.tab === 0) {
          this.formData.correspondenceCountryDescription = country ? country.codeDescription : '';
          this.formData.correspondenceStateDescription = '';
        } else if (this.tab === 1) {
          this.secondaryFormData.correspondenceCountryDescription = country ? country.codeDescription : '';
          this.secondaryFormData.correspondenceStateDescription = '';
        }
      } else if (arg1 === 'previousCountry') {
        await this.prevstatesloader($event);
        const country = this.reviewCountry.find((item) => item.codeReference === $event);

        if (this.tab === 0) {
          this.formData.previousCountryDescription = country ? country.codeDescription : '';
          this.formData.previousStateDescription = '';
        } else if (this.tab === 1) {
          this.secondaryFormData.previousCountryDescription = country ? country.codeDescription : '';
          this.secondaryFormData.previousStateDescription = '';
        }
      } else if (arg === 'manualCorresponding' || arg === 'prevManualAddress') {
      } else if (arg === 'foreignCountryOfTaxResidence') {
        this.foreignCountryOfTaxResidenceEdit = $event;
        const country = this.reviewCountry.find((item) => item.codeReference === $event);

        if (this.tab === 0) {
          this.formData.foreignCountryOfTaxResidenceDescription = country ? country.codeDescription : '';
        } else if (this.tab === 1) {
          this.secondaryFormData.previousCountryDescription = country ? country.codeDescription : '';
        }
      } else if (arg === 'employmentStatus') {
        if (this.tab === 0) {
          this.updatedEmploymentStatus = $event;
          this.employmentDetails.employmentStatusList.forEach((item) => {
            if (item.codeReference === this.updatedEmploymentStatus) {
              this.formData.employmentStatusDescription = item.codeDescription;
            }
          });
        } else {
          this.secondaryApplicantsData.updatedEmploymentStatus = $event;
          this.employmentDetails.employmentStatusList.forEach((item) => {
            if (item.codeReference === this.secondaryApplicantsData.updatedEmploymentStatus) {
              this.secondaryFormData.employmentStatusDescription = item.codeDescription;
            }
          });
        }
        if (this.tab === 0) {
          this.formData.employmentType = '';
          this.formData.nameOfTheEmployer = '';
          this.formData.businessType = '';
          this.formData.jobTitle = '';
          this.formData.paymentFrequency = '';
          this.formData.paymentMethod = '';
          this.formData.employmentTypeDescription = '';
          this.formData.businessTypeDescription = '';
          this.formData.jobTitleDescription = '';
          this.formData.paymentFrequencyDescription = '';
          this.formData.paymentMethodDescription = '';
          this.enableSaveButton('employmentDetails');
        } else if (this.tab === 1) {
          this.secondaryFormData.employmentType = '';
          this.secondaryFormData.nameOfTheEmployer = '';
          this.secondaryFormData.businessType = '';
          this.secondaryFormData.jobTitle = '';
          this.secondaryFormData.paymentFrequency = '';
          this.secondaryFormData.paymentMethod = '';
          this.secondaryFormData.employmentTypeDescription = '';
          this.secondaryFormData.businessTypeDescription = '';
          this.secondaryFormData.jobTitleDescription = '';
          this.secondaryFormData.paymentFrequencyDescription = '';
          this.secondaryFormData.paymentMethodDescription = '';
          this.enableSaveButton('employmentDetails');
        }
        return;
      } else if (arg === 'year' || arg === 'month' || arg === 'day') {
        await this.datePickerLoader($event, arg);
        this.enableSaveButton(arg);
        return;
      } else if (['titleCode', 'birthCountryCode', 'countryOfTaxResidentCode', 'foreignCountryOfTaxResidence', 'taxExemptionReason', 'employmentType',
        'businessType', 'jobTitle', 'paymentMethod', 'paymentFrequency', 'nationalIdTypeId', 'sourceCountryOfFunds', 'job', 'udfBusinessType', 'purposeOfAccount', 'expectedUsage', 'relationshipType', 'primaryNationality'].includes(arg)) {
        if (arg === 'titleCode') {
          const titles = this.items.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.titleDescription = titles ? titles.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.titleDescription = titles ? titles?.codeDescription : '';
          }
        } else if (arg === 'birthCountryCode') {
          const country = this.reviewCountry.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.birthCountryDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.birthCountryDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'countryOfTaxResidentCode') {
          const country = this.reviewCountry.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.countryOfTaxResidenceDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.countryOfTaxResidenceDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'foreignCountryOfTaxResidence') {
          const country = this.reviewCountry.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.foreignCountryOfTaxResidenceDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.foreignCountryOfTaxResidenceDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'taxExemptionReason') {
          const country = this.taxExemptionDropDown.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.taxExemptionDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.taxExemptionDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'nationalIdTypeId') {
          this.formData = Object.assign(
            {},
            {
              ...this.formData,
              ...{
                nationalIdNumber: '',
              },
            },
          );
          this.nationalIdentities.forEach((item) => {
            if (item.codeReference === $event) {
              this.formData.nationalIdTypeCode = item.codeDescription;
            }
          });
          this.enableSaveButton(arg);
        } else if (arg === 'employmentType') {
          const country = this.employmentDetails.employmentTypeList.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.employmentTypeDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.employmentTypeDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'businessType') {
          const country = this.employmentDetails.businessTypeList.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.businessTypeDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.businessTypeDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'jobTitle') {
          const country = this.employmentDetails.jobTitleList.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.jobTitleDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.jobTitleDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'paymentMethod') {
          const country = this.employmentDetails.paymentMethodList.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.paymentMethodDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.paymentMethodDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'paymentFrequency') {
          const country = this.employmentDetails.paymentFrequencyList.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.paymentFrequencyDescription = country ? country.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.paymentFrequencyDescription = country ? country?.codeDescription : '';
          }
        } else if (arg === 'sourceCountryOfFunds') {
          const codeReferenceValue = this.reviewInformation.complianceDetails[1].displayValue;
          const sourceCountryOfFunds = this.sourceCountryOfFunds.find((item) => item[codeReferenceValue] === $event);

          if (this.tab === 0) {
            this.formData.sourceCountryOfFundsDescription = sourceCountryOfFunds ? sourceCountryOfFunds.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.sourceCountryOfFundsDescription = sourceCountryOfFunds ? sourceCountryOfFunds.codeDescription : '';
          }
        } else if (arg === 'job') {
          const codeReferenceValue = this.reviewInformation.complianceDetails[2].displayValue;
          const job = this.jobDropDown.find((item) => item[codeReferenceValue] === $event);

          if (this.tab === 0) {
            this.formData.jobDescription = job ? job.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.jobDescription = job ? job.codeDescription : '';
          }
        } else if (arg === 'udfBusinessType') {
          const codeReferenceValue = this.reviewInformation.complianceDetails[3].displayValue;
          const udfBusinessType = this.udfBusinessTypeDropdown.find((item) => item[codeReferenceValue] === $event);

          if (this.tab === 0) {
            this.formData.udfBusinessTypeDescription = udfBusinessType ? udfBusinessType.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.udfBusinessTypeDescription = udfBusinessType ? udfBusinessType.codeDescription : '';
          }
        } else if (arg === 'purposeOfAccount') {
          const codeReferenceValue = this.reviewInformation.productEditDetails[0].displayValue;
          const purposeOfAccount = this.purposeOfAccountDropdown.find((item) => item[codeReferenceValue] === $event);

          if (this.tab === 0) {
            this.formData.purposeOfAccountDescription = purposeOfAccount ? purposeOfAccount.codeDescription : '';
            this.formData.purposeOfAccountOthers = purposeOfAccount?.codeReference === 'ACCPURPOSE7' ? this.formData.purposeOfAccountOthers : '';
            this.updatedPurposeOfAccountOther = purposeOfAccount?.codeReference === 'ACCPURPOSE7';
          } else if (this.tab === 1) {
            this.secondaryFormData.purposeOfAccountDescription = purposeOfAccount ? purposeOfAccount.codeDescription : '';
          }
        } else if (arg === 'expectedUsage') {
          const codeReferenceValue = this.reviewInformation.productEditDetails[2].displayValue;
          const expectedUsage = this.expectedUsageDropdown.find((item) => item[codeReferenceValue] === $event);

          if (this.tab === 0) {
            this.formData.expectedUsageDescription = expectedUsage ? expectedUsage.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.expectedUsageDescription = expectedUsage ? expectedUsage.codeDescription : '';
          }
        } else if (arg === 'relationshipType') {
          const relationshipType = this.relationshipTypeDropDown.find((item) => item.relationshipType === $event);

          this.secondaryFormData.relationshipTypeDescription = relationshipType ? relationshipType.relationshipTypeDescription : '';
        } else if (arg === 'primaryNationality') {
          const primaryNationality = this.reviewNationality.find((item) => item.codeReference === $event);

          if (this.tab === 0) {
            this.formData.primaryNationalityDescription = primaryNationality ? primaryNationality.codeDescription : '';
          } else if (this.tab === 1) {
            this.secondaryFormData.primaryNationalityDescription = primaryNationality ? primaryNationality?.codeDescription : '';
          }
        }
      } else if (nestedValue === 'primaryAddress') {
        const state = this.primaryStatesDropdown?.find((item) => item.stateOrProvince === $event);

        if (this.tab === 0) {
          this.formData.primaryStateDescription = state ? state.stateOrProvinceDescription : '';
        } else if (this.tab === 1) {
          this.secondaryFormData.primaryStateDescription = state ? state.stateOrProvinceDescription : '';
        }
      } else if (nestedValue === 'correspondenceAddress') {
        const state = this.corrStatesDropdown?.find((item) => item.stateOrProvince === $event);

        if (this.tab === 0) {
          this.formData.correspondenceStateDescription = state ? state.stateOrProvinceDescription : '';
        } else if (this.tab === 1) {
          this.secondaryFormData.correspondenceStateDescription = state ? state.stateOrProvinceDescription : '';
        }
      } else if (nestedValue === 'previousResidentialAddress') {
        const state = this.prevStatesDropdown?.find((item) => item.stateOrProvince === $event);

        if (this.tab === 0) {
          this.formData.previousStateDescription = state ? state.stateOrProvinceDescription : '';
        } else if (this.tab === 1) {
          this.secondaryFormData.previousStateDescription = state ? state.stateOrProvinceDescription : '';
        }
      }
      if (arg === 'nationalIdNumber') {
        let formatValidationCheck = false; ;
        if ((this.formData.nationalIdTypeId === 'NATIONAL_ID_006' && /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])\d{6}([A-D])$/.test(this.formData.nationalIdNumber)) || (this.formData.nationalIdTypeId !== 'NATIONAL_ID_006' && this.formData.nationalIdNumber !== '' && /^[A-Za-z0-9-]*$/.test(this.formData.nationalIdNumber))) {
          formatValidationCheck = true;
        }
        if (formatValidationCheck) {
          const dedupCheck = await CommonService.dedupCheck(`${urlObj.dedupCheck}/${'nationalIdCheck=true'}`, {
            mobileCountryCode: null,
            mobilePhoneNumber: null,
            emailAddress: null,
            dateOfBirth: null,
            idType: this.tab === 0 ? this.formData.nationalIdTypeId : this.secondaryApplicantsData.nationalIdTypeId,
            idNumber: this.tab === 0 ? this.formData.nationalIdNumber : this.secondaryApplicantsData.nationalIdNumber,
          });

          if (dedupCheck?.status === 400) {
            this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: dedupCheck.causes[0].message, type: 'error' });
          }
          if (dedupCheck.dedupCheckStatusMessage !== null && dedupCheck.isDedupCheckPassed === false) {
            this.formData = Object.assign(
              {},
              {
                ...this.formData,
                ...{
                  nationalIdNumber: '',
                },
              },
            );
            this.dedupCheckFailed = true;
          }
        }
        this.enableSaveButton(arg);
      }
      if (nestedValue === 'taxDetails' || nestedValue === 'personalDetails' || nestedValue === 'employmentDetails' || nestedValue === 'complianceDetails' || nestedValue === 'udfProductDetails') {
        this.enableSaveButton(nestedValue);
        return;
      }
      if (arg2 === 'addressDetails') {
        this.enableSaveButton(arg2);
      }
    },
    async addressInformationData(tab) {
      const reviewMappingsData = store.getters['userStore/userData']?.additionalInfoData;

      if (tab === 0) {
        const primaryAddress = this.contactReviewData?.primaryAddress;
        const correspondenceAddress = this.contactReviewData?.correspondenceAddress;
        const previousResidentialAddress = this.contactReviewData?.previousResidentialAddress;

        this.isAddressLookupEnabled = this.isAddressLookupEnabled ? this.isAddressLookupEnabled : !!(primaryAddress?.addressID && primaryAddress?.addressID !== '');
        this.contactDetails = this.contactReviewData;
        this.primaryReview = primaryAddress?.addressText && primaryAddress?.addressText !== '' ? this.decodeHtmlEntities(this.contactReviewData.primaryAddress?.addressText) : [primaryAddress?.addressLine1, primaryAddress?.addressLine2, primaryAddress?.addressLine3,
        primaryAddress?.addressLine4, primaryAddress?.city, primaryAddress?.stateOrprovinceName, primaryAddress?.countryName, primaryAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');

        // assigning read only value if correspondence address is captured.
        if (correspondenceAddress !== undefined) {
          if (primaryAddress?.addressLine1 === correspondenceAddress?.addressLine1) {
            this.sameAsResidential = true;
          } else {
            this.correspondenceReview = correspondenceAddress?.addressText !== '' ? this.decodeHtmlEntities(correspondenceAddress?.addressText) : [correspondenceAddress?.addressLine1, correspondenceAddress?.addressLine2,
            correspondenceAddress?.addressLine3, correspondenceAddress?.addressLine4, correspondenceAddress?.city,
            correspondenceAddress?.stateOrprovinceName, correspondenceAddress?.countryName, correspondenceAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');
          }
        }

        // assigning read only values if previous residential address is captured.
        if (previousResidentialAddress !== undefined) {
          this.previousReview = previousResidentialAddress?.addressText !== '' ? this.decodeHtmlEntities(this.contactReviewData.previousResidentialAddress?.addressText) : [previousResidentialAddress?.addressLine1, previousResidentialAddress?.addressLine2,
            previousResidentialAddress?.addressLine3, previousResidentialAddress?.addressLine4,
            previousResidentialAddress?.city, previousResidentialAddress?.stateOrprovinceName, previousResidentialAddress?.countryName,
            previousResidentialAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');
          this.readOnlyFromDate = moment(this.contactReviewData.previousResidentialAddress?.fromDate).format('DD-MM-YYYY');
          this.readOnlyToDate = moment(this.contactReviewData.previousResidentialAddress?.toDate).format('DD-MM-YYYY');
        }

        // assigning edit tab values of address section.
        this.addressSameAsPrimary = this.contactReviewData && this.contactReviewData?.secondaryApplicantsContactInformation && this.contactReviewData?.secondaryApplicantsContactInformation[0] ? JSON.stringify(primaryAddress) === JSON.stringify(this.contactReviewData?.secondaryApplicantsContactInformation[0]?.primaryAddress) &&
        JSON.stringify(correspondenceAddress) === JSON.stringify(this.contactReviewData?.secondaryApplicantsContactInformation[0]?.correspondenceAddress) : '';
        this.addressAddedManually = primaryAddress?.addressText === undefined || primaryAddress?.addressText === '';

        if (!this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'false' || this.addressAddedManually) {
          this.addressAddedManually = true;
          this.contactInformationData(0, reviewMappingsData);
          this.manualInputCorresponding = this.formData?.correspondenceAddress?.addressLine1 ? (this.formData.primaryAddress.addressLine1 === this.formData.correspondenceAddress.addressLine1) : true;
          this.prevManualAddress = this.formData?.previousResidentialAddress?.addressLine1 ? (this.formData.primaryAddress.addressLine1 === this.formData.previousResidentialAddress.addressLine1) : true;
          this.isDefaultManual = !!((primaryAddress.isDefault === 'true' || primaryAddress.isDefault === true));

          if (this.formData?.primaryAddress?.country && this.formData?.primaryAddress?.country !== '' && primaryAddress?.stateOrprovince !== '') {
            const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${this.formData?.primaryAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);

            this.primaryStatesDropdown = Array.isArray(primaryState?.data) ? primaryState.data : [];
          }
          if (this.formData?.correspondenceAddress?.country && this.formData?.correspondenceAddress?.country !== '' && correspondenceAddress?.stateOrprovince !== '') {
            const corrState = await CommonService.getStatesDropDown(`${urlObj.states}/${this.formData?.correspondenceAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);

            this.corrStatesDropdown = Array.isArray(corrState?.data) ? corrState.data : [];
          }
          if (this.formData?.previousResidentialAddress?.country && this.formData?.previousResidentialAddress?.country !== '' && previousResidentialAddress?.stateOrprovince !== '') {
            const prevState = await CommonService.getStatesDropDown(
                  `${urlObj.states}/${this.formData?.previousResidentialAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);

            this.prevStatesDropdown = Array.isArray(prevState?.data) ? prevState.data : [];
          }
        } else if ((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && !this.addressAddedManually) {
          this.residentialAddress = primaryAddress?.addressText;
          this.isDefault = !!((primaryAddress?.isDefault === 'true' || primaryAddress?.isDefault === true));
          if (correspondenceAddress !== undefined && correspondenceAddress !== null) {
            if (primaryAddress?.addressLine1 === correspondenceAddress?.addressLine1) {
              this.reviewCorresponding = true;
            } else {
              this.reviewCorresponding = false;
              this.correspondenceAddress = correspondenceAddress?.addressText;
            }
          }
          if (!previousResidentialAddress) {
            this.selected = true;
          } else {
            this.selected = false;
            this.previousResidentialAddress = previousResidentialAddress?.addressText;
            this.fromDate = previousResidentialAddress?.fromDate;
            this.toDate = previousResidentialAddress?.toDate;
          }
        }
        this.isDefaultManual = !!((primaryAddress?.isDefault === 'true' || primaryAddress?.isDefault === true));
        this.fromDate = previousResidentialAddress?.fromDate !== '' ? previousResidentialAddress?.fromDate : this.formData && this.formData?.previousResidentialAddress && this.formData?.previousResidentialAddress?.fromDate !== '' ? this.formData?.previousResidentialAddress?.fromDate : '';
        this.toDate = previousResidentialAddress?.toDate !== '' ? previousResidentialAddress?.toDate : this.formData && this.formData?.previousResidentialAddress && this.formData?.previousResidentialAddress?.toDate !== '' ? this.formData?.previousResidentialAddress?.toDate : '';
        this.formData = Object.assign(
          {},
          {
            ...this.formData,
            ...{
              primaryCountryDescription: primaryAddress?.countryName,
              correspondenceCountryDescription: correspondenceAddress?.countryName,
              previousCountryDescription: previousResidentialAddress?.countryName,
              primaryStateDescription: primaryAddress?.stateOrprovinceName,
              correspondenceStateDescription: correspondenceAddress?.stateOrprovinceName,
              previousStateDescription: previousResidentialAddress?.stateOrprovinceName,
            },
          },
        );
      } else if (tab === 1) {
        const contactReviewData = JSON.parse(reviewMappingsData.contactInformation)?.secondaryApplicantsContactInformation[0];
        const primaryAddress = contactReviewData?.primaryAddress;
        const correspondenceAddress = contactReviewData?.correspondenceAddress;
        const previousResidentialAddress = contactReviewData?.previousResidentialAddress;

        this.secondaryContactDetails = contactReviewData;
        this.secondaryApplicantsData.primaryReview = primaryAddress?.addressText && primaryAddress?.addressText !== '' ? this.decodeHtmlEntities(primaryAddress?.addressText) : [primaryAddress?.addressLine1, primaryAddress?.addressLine2, primaryAddress?.addressLine3,
        primaryAddress?.addressLine4, primaryAddress?.city, primaryAddress?.stateOrprovinceName, primaryAddress?.countryName, primaryAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');

        // assigning read only value if correspondence address is captured.
        if (correspondenceAddress !== undefined) {
          if (primaryAddress?.addressLine1 === correspondenceAddress?.addressLine1) {
            this.secondaryApplicantsData.sameAsResidential = true;
          } else {
            this.secondaryApplicantsData.correspondenceReview = correspondenceAddress?.addressText !== '' ? this.decodeHtmlEntities(correspondenceAddress?.addressText) : [correspondenceAddress?.addressLine1, correspondenceAddress?.addressLine2,
            correspondenceAddress?.addressLine3, correspondenceAddress?.addressLine4, correspondenceAddress?.city,
            correspondenceAddress?.stateOrprovinceName, correspondenceAddress?.countryName, correspondenceAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');
          }
        }

        // assigning read only values if previous residential address is captured.
        if (previousResidentialAddress !== undefined) {
          this.secondaryApplicantsData.previousReview = previousResidentialAddress?.addressText !== '' ? this.decodeHtmlEntities(previousResidentialAddress?.addressText) : [previousResidentialAddress?.addressLine1, previousResidentialAddress?.addressLine2,
            previousResidentialAddress?.addressLine3, previousResidentialAddress?.addressLine4,
            previousResidentialAddress?.city, previousResidentialAddress?.stateOrprovinceName, previousResidentialAddress?.countryName,
            previousResidentialAddress?.postCode.toUpperCase()].filter(Boolean).join(', ');
          this.secondaryApplicantsData.readOnlyFromDate = moment(previousResidentialAddress?.fromDate).format('DD-MM-YYYY');
          this.secondaryApplicantsData.readOnlyToDate = moment(previousResidentialAddress?.toDate).format('DD-MM-YYYY');
        }

        // assigning edit tab values of address section.
        this.addressSameAsPrimary = JSON.stringify(this.contactReviewData.primaryAddress) === JSON.stringify(this.contactReviewData?.secondaryApplicantsContactInformation[0]?.primaryAddress) &&
        JSON.stringify(this.contactReviewData.correspondenceAddress) === JSON.stringify(this.contactReviewData?.secondaryApplicantsContactInformation[0]?.correspondenceAddress);
        this.secondaryAddressAddedManually = !(primaryAddress?.addressID && primaryAddress?.addressID !== '');

        if (this.isAddressLookupEnabled === 'false' || this.secondaryAddressAddedManually) {
          const data = {
            contactInformation: JSON.stringify(contactReviewData),
          };
          this.secondaryAddressAddedManually = true;
          this.contactInformationData(1, data);
          this.manualInputCorresponding = this.secondaryFormData?.correspondenceAddress?.addressLine1 ? (this.secondaryFormData.primaryAddress.addressLine1 === this.secondaryFormData.correspondenceAddress.addressLine1) : true;
          this.prevManualAddress = this.secondaryFormData?.previousResidentialAddress?.addressLine1 ? (this.secondaryFormData.primaryAddress.addressLine1 === this.secondaryFormData.previousResidentialAddress.addressLine1) : true;
          this.isDefaultManual = !!((primaryAddress.isDefault === 'true' || primaryAddress.isDefault === true));

          if (this.secondaryFormData?.primaryAddress?.country && this.secondaryFormData?.primaryAddress?.country !== '' && primaryAddress?.stateOrprovince !== '') {
            const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${this.secondaryFormData?.primaryAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
            this.secondaryApplicantsData.primaryStatesDropdown = Array.isArray(primaryState?.data) ? primaryState.data : [];
          }
          if (this.secondaryFormData?.correspondenceAddress?.country && this.secondaryFormData?.correspondenceAddress?.country !== '' && correspondenceAddress?.stateOrprovince !== '') {
            const corrState = await CommonService.getStatesDropDown(`${urlObj.states}/${this.secondaryFormData?.correspondenceAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
            this.secondaryApplicantsData.corrStatesDropdown = Array.isArray(corrState?.data) ? corrState.data : [];
          }
          if (this.secondaryFormData?.previousResidentialAddress?.country && this.secondaryFormData?.previousResidentialAddress?.country !== '' && previousResidentialAddress?.stateOrprovince !== '') {
            const prevState = await CommonService.getStatesDropDown(
                  `${urlObj.states}/${this.secondaryFormData?.previousResidentialAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
            this.secondaryApplicantsData.prevStatesDropdown = Array.isArray(prevState?.data) ? prevState.data : [];
          }
        } else if ((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && !this.secondaryAddressAddedManually) {
          this.secondaryResidentialAddress = primaryAddress?.addressText;
          this.isDefaultSecondary = !!((primaryAddress?.isDefault === 'true' || primaryAddress?.isDefault === true));
          if (correspondenceAddress !== undefined && correspondenceAddress !== null) {
            if (primaryAddress?.addressLine1 === correspondenceAddress?.addressLine1) {
              this.secondaryReviewCorresponding = true;
            } else {
              this.secondaryReviewCorresponding = false;
              this.secondaryCorrespondenceAddress = correspondenceAddress?.addressText;
            }
          }
          if (!previousResidentialAddress) {
            this.secondarySelected = true;
          } else {
            this.secondarySelected = false;
            this.secondaryPreviousResidentialAddress = previousResidentialAddress?.addressText;
            this.fromDate = previousResidentialAddress?.fromDate;
            this.toDate = previousResidentialAddress?.toDate;
          }
        }

        this.secondaryManualInputCorresponding = this.secondaryFormData?.correspondenceAddress?.addressLine1 ? (this.secondaryFormData.primaryAddress.addressLine1 === this.secondaryFormData.correspondenceAddress.addressLine1) : true;
        this.secondaryPrevManualAddress = this.secondaryFormData?.previousResidentialAddress?.addressLine1 ? (this.secondaryFormData.primaryAddress.addressLine1 === this.secondaryFormData.previousResidentialAddress.addressLine1) : true;
        this.isDefaultManualSecondary = !!((primaryAddress.isDefault === 'true' || primaryAddress.isDefault === true));
        this.secondaryFromDate = previousResidentialAddress?.fromDate !== '' ? previousResidentialAddress?.fromDate : this.secondaryFormData && this.secondaryFormData?.previousResidentialAddress && this.secondaryFormData?.previousResidentialAddress?.fromDate !== '' ? this.secondaryFormData?.previousResidentialAddress?.fromDate : '';
        this.secondaryToDate = previousResidentialAddress?.toDate !== '' ? previousResidentialAddress?.toDate : this.secondaryFormData && this.secondaryFormData?.previousResidentialAddress && this.secondaryFormData?.previousResidentialAddress?.toDate !== '' ? this.secondaryFormData?.previousResidentialAddress?.toDate : '';
        this.secondaryFormData = Object.assign(
          {},
          {
            ...this.secondaryFormData,
            ...{
              primaryCountryDescription: primaryAddress?.countryName,
              correspondenceCountryDescription: correspondenceAddress?.countryName,
              previousCountryDescription: previousResidentialAddress?.countryName,
              primaryStateDescription: primaryAddress?.stateOrprovinceName,
              correspondenceStateDescription: correspondenceAddress?.stateOrprovinceName,
              previousStateDescription: previousResidentialAddress?.stateOrprovinceName,
            },
          },
        );
      }
      this.loaderEnabled = false;
      store.dispatch('appStore/setAppData', {
        inProgress: false,
      });
    },
    contactInformationData(tab, reviewMappingsData) {
      const tabWiseFormData = tab === 0 ? 'formData' : 'secondaryFormData';

      for (const data in this.reviewInformation) {
        if (data === 'manualInputOfAddress') {
          this.reviewInformation[data].forEach((element) => {
            for (const test in element) {
              if (element[test] && element[test].length > 0) {
                element[test].forEach((thisdata) => {
                  if (thisdata.mapValue) {
                    const value = thisdata.mapValue.slice(1, -1);
                    const assignValue = JSON.parse(reviewMappingsData[value]);

                    if (assignValue[thisdata.nestedValue] && assignValue[thisdata.nestedValue][thisdata.key]) {
                      this[tabWiseFormData][test][thisdata.key] = assignValue[thisdata.nestedValue][thisdata.key];
                    } else {
                      this[tabWiseFormData][test][thisdata.key] = '';
                    }
                  }
                });
              }
            }
          });
        }
      }
    },
    async personalInformationData(tab) {
      const personalData = this.personalReviewData;
      const date = tab === 0 ? new Date(personalData.dateOfBirth) : new Date(personalData.secondaryApplicantsPersonalInformation[0]?.dateOfBirth);
      const splitDateOfBirth = tab === 0 ? personalData.dateOfBirth.split('-') : personalData.secondaryApplicantsPersonalInformation[0]?.dateOfBirth.split('-');
      const year = date.getFullYear();
      const month = (moment.months()[date.getMonth()]).substring(0, 3);
      const day = date.getDate();

      let ageValidationCheck = false;

      if (tab === 0) {
        this.dateOfBirth = `${year} ${month} ${day}`;
        this.reviewReadOnlyGender = personalData?.gender === '001' ? this.$t('reviewInformation.item.gender.Female') : personalData?.gender === '002' ? this.$t('reviewInformation.item.gender.Male') : this.$t(`reviewInformation.item.gender.${'Prefer not to respond'}`);
        this.ukResident = personalData.areYouAUKResident === 'true' || personalData.areYouAUKResident === true ? 'UK resident' : personalData.areYouAUKResident === '' ? 'UK resident' : 'Not an UK resident';
        // assigning edit field values.
        this.editEnable('personalDetails', 0);
        this.formData = Object.assign(
          {},
          {
            ...this.formData,
            ...{
              areYouAUKResident: true,
              reviewMiddleNameCheckbox: !!(this.formData?.middleName && this.formData?.middleName !== ''),
              reviewAnotherNationality: !!(this.formData?.secondaryNationality && this.formData?.secondaryNationality),
              year: splitDateOfBirth[0],
              month: splitDateOfBirth[1],
              date: splitDateOfBirth[2],
              titleDescription: personalData.titleDescription,
              birthCountryDescription: personalData.birthCountryName,
              primaryNationalityDescription: personalData?.primaryNationalityDescription,
            },
          },
        );
        this.reviewMiddleNameCheckbox = !!(this.formData?.middleName && this.formData?.middleName !== '');
        this.reviewAnotherNationality = !!(this.formData?.secondaryNationality && this.formData?.secondaryNationality);

        ageValidationCheck = personalData && this.otherInformation?.lisaTransferInWithAgeValidation !== undefined &&
      this.otherInformation?.lisaTransferInWithAgeValidation !== null ? this.otherInformation?.lisaTransferInWithAgeValidation === 'true' || this.otherInformation?.lisaTransferInWithAgeValidation
          : localStorage.getItem('isLisaTransferInWithAgeCheck') === 'true';
      } else {
        this.secondaryApplicantsData = Object.assign(
          {},
          {
            ...this.secondaryApplicantsData,
            ...{
              dateOfBirth: `${year} ${month} ${day}`,
              titleDescription: personalData.secondaryApplicantsPersonalInformation[0]?.titleDescription,
              reviewReadOnlyGender: personalData.secondaryApplicantsPersonalInformation[0]?.gender === '001' ? this.$t('reviewInformation.item.gender.Female') : personalData.secondaryApplicantsPersonalInformation[0]?.gender === '002' ? this.$t('reviewInformation.item.gender.Male') : this.$t(`reviewInformation.item.gender.${'Prefer not to respond'}`),
              ukResident: personalData.secondaryApplicantsPersonalInformation[0].areYouAUKResident === 'true' || personalData.secondaryApplicantsPersonalInformation[0].areYouAUKResident === true ? 'UK resident' : personalData.secondaryApplicantsPersonalInformation[0].areYouAUKResident === '' ? 'UK resident' : 'Not an UK resident',
              firstName: personalData.secondaryApplicantsPersonalInformation[0]?.firstName,
              middleName: personalData.secondaryApplicantsPersonalInformation[0]?.middleName,
              lastName: personalData.secondaryApplicantsPersonalInformation[0]?.lastName,
              primaryNationality: personalData.secondaryApplicantsPersonalInformation[0]?.primaryNationality,
              primaryNationalityDescription: personalData.secondaryApplicantsPersonalInformation[0]?.primaryNationalityDescription,
              birthCountryName: personalData.secondaryApplicantsPersonalInformation[0]?.birthCountryName,
              nationalIdTypeCode: personalData.secondaryApplicantsPersonalInformation[0]?.nationalIdTypeCode,
              nationalIdNumber: personalData.secondaryApplicantsPersonalInformation[0]?.nationalIdNumber,
            },
          },
        );
        // assigning edit field values.
        this.editEnable('personalDetails', 1);
        this.secondaryFormData = Object.assign(
          {},
          {
            ...this.secondaryFormData,
            ...{
              areYouAUKResident: true,
              reviewMiddleNameCheckbox: !!(this.secondaryFormData?.middleName && this.secondaryFormData?.middleName !== ''),
              reviewAnotherNationality: !!(this.secondaryFormData?.secondaryNationality && this.secondaryFormData?.secondaryNationality),
              year: splitDateOfBirth[0],
              month: splitDateOfBirth[1],
              date: splitDateOfBirth[2],
              titleDescription: personalData.secondaryApplicantsPersonalInformation[0].titleDescription,
              birthCountryDescription: personalData.secondaryApplicantsPersonalInformation[0].birthCountryName,
            },
          },
        );
        this.secondaryFormData.reviewMiddleNameCheckbox = !!(this.secondaryFormData?.middleName && this.secondaryFormData?.middleName !== '');
        this.secondaryFormData.reviewAnotherNationality = !!(this.secondaryFormData?.secondaryNationality && this.secondaryFormData?.secondaryNationality);

        const otherInformation = this.otherInformation?.secondaryApplicantsOtherInformation[0];

        ageValidationCheck = personalData.secondaryApplicantsPersonalInformation[0] && otherInformation?.lisaTransferInWithAgeValidation !== undefined &&
      otherInformation?.lisaTransferInWithAgeValidation !== null ? otherInformation?.lisaTransferInWithAgeValidation === 'true' || otherInformation?.lisaTransferInWithAgeValidation
          : localStorage.getItem('isLisaTransferInWithAgeCheck') === 'true';
      }

      if (this.productType === 'lifetimeISA' && ageValidationCheck) {
        const lisaYears = new Date().getFullYear() - 39;
        const tabWiseFormData = tab === 0 ? 'formData' : 'secondaryFormData';
        const validationPassed = (Number(this[tabWiseFormData].year) < lisaYears) ||
        (Number(this[tabWiseFormData].year) === lisaYears && Number(this[tabWiseFormData].month) - 1 > new Date().getMonth()) ||
        ((Number(this[tabWiseFormData].year) === lisaYears && Number(this[tabWiseFormData].month) - 1 === new Date().getMonth() && Number(this[tabWiseFormData].date) > new Date().getDate()));

        if (validationPassed) {
          this[tabWiseFormData] = {
            year: '',
            month: '',
            date: '',
          };
        }
      }
    },
    async taxInformationData(tab) {
      if (tab === 0) {
        this.taxResidentInOtherCountry = this.taxReviewData.taxResidentInOtherCountry;
        this.taxValue = this.taxReviewData && (this.taxReviewData?.taxPayerFlag === 'true' || this.taxReviewData?.taxPayerFlag === true);
        this.usResident = (this.taxReviewData.areYouUSResident === 'true' || this.taxReviewData.areYouUSResident === true) ? 'USA resident' : 'Not a USA resident';
        // assigning edit field values.
        this.editEnable('taxDetails', 0);
        this.readOnlyTaxValue = this.taxReview && (this.taxReview?.taxPayerFlag === 'true' || this.taxReview?.taxPayerFlag === true);
        this.taxValue = this.getProductType === 'lifetimeISA' ? true : this.taxValue;
        this.taxResidentInOtherCountry = this.formData.taxResidentInOtherCountry === 'true' || this.formData.taxResidentInOtherCountry === true;
        this.areYouUSResident = this.taxResidentInOtherCountry ? this.formData.areYouUSResident === 'true' || this.formData.areYouUSResident === true : false;
        this.foreignCountryOfTaxResidence = this.taxResidentInOtherCountry ? this.formData.foreignCountryOfTaxResidence : '';
        this.formData = Object.assign(
          {},
          {
            ...this.formData,
            ...{
              areYouUSResident: this.formData.areYouUSResident !== '' ? this.formData.areYouUSResident === 'true' || this.formData.areYouUSResident === true : false,
              taxResidentInOtherCountry: !!(this.formData.taxResidentInOtherCountry === 'true' || this.formData.taxResidentInOtherCountry === true),
              countryOfTaxResidenceDescription: this.taxReviewData.countryOfTaxResidentName || 'United Kingdom',
              foreignCountryOfTaxResidenceDescription: this.taxReviewData.foreignCountryOfTaxResidenceName,
              taxExemptionDescription: this.taxReviewData.taxExemptionReasonName,
            },
          },
        );
      } else {
        const taxData = this.taxReviewData?.secondaryApplicantsTaxInformation[0];

        this.secondaryApplicantsData = Object.assign(
          {},
          {
            ...this.secondaryApplicantsData,
            ...{
              taxResidentInOtherCountry: taxData.taxResidentInOtherCountry,
              taxValue: taxData && (taxData?.taxPayerFlag === 'true' || taxData?.taxPayerFlag === true),
              usResident: (taxData.areYouUSResident === 'true' || taxData.areYouUSResident === true) ? 'USA resident' : 'Not a USA resident',
            },
          },
        );
        // assigning edit field values.
        this.editEnable('taxDetails', 1);
        this.readOnlyTaxValueSecondary = taxData && (taxData?.taxPayerFlag === 'true' || taxData?.taxPayerFlag === true);
        this.secondaryTaxValue = this.productType === 'lifetimeISA' ? true : taxData?.taxPayerFlag !== '' ? taxData?.taxPayerFlag === 'true' || taxData?.taxPayerFlag === true : false;
        this.secondaryTaxResidentInOtherCountry = this.secondaryFormData.taxResidentInOtherCountry === 'true' || this.secondaryFormData.taxResidentInOtherCountry === true;
        this.secondaryAreYouUSResident = this.secondaryTaxResidentInOtherCountry ? this.secondaryFormData.areYouUSResident === 'true' || this.secondaryFormData.areYouUSResident === true : false;
        this.secondaryForeignCountryOfTaxResidence = this.secondaryTaxResidentInOtherCountry ? this.secondaryFormData.foreignCountryOfTaxResidence : '';
        this.secondaryFormData = Object.assign(
          {},
          {
            ...this.secondaryFormData,
            ...{
              areYouUSResident: this.secondaryFormData.areYouUSResident !== '' ? this.secondaryFormData.areYouUSResident === 'true' || this.secondaryFormData.areYouUSResident === true : false,
              taxResidentInOtherCountry: !!(this.secondaryFormData.taxResidentInOtherCountry === 'true' || this.secondaryFormData.taxResidentInOtherCountry === true),
              countryOfTaxResidenceDescription: taxData.countryOfTaxResidentName || 'United Kingdom',
              foreignCountryOfTaxResidenceDescription: taxData.foreignCountryOfTaxResidenceName,
              taxExemptionDescription: taxData.taxExemptionReasonName,
            },
          },
        );
      }
    },
    employmentInformationData(tab) {
      const otherInformationData = this.otherInformation;

      if (tab === 0) {
        const employmentInformation = otherInformationData?.employmentDetails;

        this.updatedEmploymentStatus = otherInformationData?.employmentDetails?.employmentStatus;
        // assigning edit field values.
        this.editEnable('employmentDetails', 0);
        this.formData = Object.assign(
          {},
          {
            ...this.formData,
            ...{
              employmentStatusDescription: employmentInformation?.employmentStatusDescription || '',
              employmentTypeDescription: employmentInformation?.employmentTypeDescription || '',
              businessTypeDescription: employmentInformation?.businessTypeDescription || '',
              jobTitleDescription: employmentInformation?.jobTitleDescription || '',
              paymentMethodDescription: employmentInformation?.paymentMethodDescription || '',
              paymentFrequencyDescription: employmentInformation?.paymentFrequencyDescription || '',
            },
          },
        );
      } else {
        const employmentInformation = otherInformationData?.secondaryApplicantsOtherInformation[0]?.employmentDetails;

        this.secondaryApplicantsData.updatedEmploymentStatus = employmentInformation?.employmentStatus;
        // assigning edit field values.
        this.editEnable('employmentDetails', 1);
        this.secondaryFormData = Object.assign(
          {},
          {
            ...this.secondaryFormData,
            ...{
              employmentStatusDescription: employmentInformation?.employmentStatusDescription || '',
              employmentTypeDescription: employmentInformation?.employmentTypeDescription || '',
              businessTypeDescription: employmentInformation?.businessTypeDescription || '',
              jobTitleDescription: employmentInformation?.jobTitleDescription || '',
              paymentMethodDescription: employmentInformation?.paymentMethodDescription || '',
              paymentFrequencyDescription: employmentInformation?.paymentFrequencyDescription || '',
            },
          },
        );
      }
    },
    async accountInformationData() {
      const accountInfoData = this.accountInfoData;

      if (accountInfoData !== null && accountInfoData !== '' && accountInfoData !== undefined) {
        this.ibanValue = !!(accountInfoData.isIBANAvailable === 'true' || accountInfoData.isIBANAvailable === true);
        this.ibanNumber = accountInfoData?.iban;
        this.bicCode = accountInfoData?.bicCode;
        this.finalCurrency = accountInfoData?.currency;
        this.finalBankName = accountInfoData?.bankName;
        this.accountNumber = accountInfoData?.accountNumber;
        this.sortCodeFinal = accountInfoData?.sortCode;

        this.fileStatus = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.entityId}/${'FECO_PROOF_CATEGORY_ACCOUNT'}/${'Primary'}`, { b2bSessionId: this.b2bSessionId });
        this.filename = this.fileStatus?.data[0]?.documentName ? this.fileStatus?.data[0]?.documentName : this.fileStatus?.documentName || 'Upload Statement Proof';
        this.fileSize = this.fileStatus?.data[0]?.documentName ? Math.round(window.atob(this.fileStatus?.data[0]?.documentData).length / 1024) + ' Kb' : '';
        this.fileComponent = this.fileSize === '';
      }
      this.finalCurrency = this.ibanValue ? accountInfoData?.currency : 'GBP';
    },
    udfInformationData(tab, editedUdfSection, allUDFs) {
      const personalData = this.personalReviewData;
      const productData = this.productInformation;

      if (tab === 0) {
        this.expectedTurnover = personalData?.expectedTurnover;
        this.sourceOfFunds = personalData?.sourceCountryOfFundsDescription;
        this.jobReadOnly = personalData?.jobDescription;
        this.udfBusinessTypeReadOnly = personalData?.udfBusinessTypeDescription;
        this.purposeOfAccount = productData?.purposeOfAccountDescription;
        this.purposeOfAccountOthers = productData?.purposeOfAccountOthers;
        this.expectedUsage = productData?.expectedUsageDescription;
        this.updatedPurposeOfAccountOther = productData?.purposeOfAccount === 'ACCPURPOSE7';
        if (allUDFs === true) {
          // assigning edit field values.
          this.editEnable('complianceDetails', 0);
          this.formData = Object.assign(
            {},
            {
              ...this.formData,
              ...{
                sourceCountryOfFunds: personalData?.sourceCountryOfFunds ? personalData.sourceCountryOfFunds : '',
                job: personalData?.job ? personalData.job : '',
                udfBusinessType: personalData?.udfBusinessType ? personalData.udfBusinessType : '',
                expectedTurnover: personalData?.expectedTurnover ? personalData.expectedTurnover : '',
                purposeOfAccount: productData?.purposeOfAccount ? productData.purposeOfAccount : '',
                purposeOfAccountOthers: productData?.purposeOfAccountOthers ? productData.purposeOfAccountOthers : '',
                expectedUsage: productData?.expectedUsage ? productData.expectedUsage : '',
              },
            },
          );
        } else {
          if (editedUdfSection && editedUdfSection === 'complianceDetails') {
            this.formData = Object.assign(
              {},
              {
                ...this.formData,
                ...{
                  sourceCountryOfFunds: personalData?.sourceCountryOfFunds ? personalData.sourceCountryOfFunds : '',
                  job: personalData?.job ? personalData.job : '',
                  udfBusinessType: personalData?.udfBusinessType ? personalData.udfBusinessType : '',
                  expectedTurnover: personalData?.expectedTurnover ? personalData.expectedTurnover : '',
                },
              },
            );
          } else {
            this.formData = Object.assign(
              {},
              {
                ...this.formData,
                ...{
                  purposeOfAccount: productData?.purposeOfAccount ? productData.purposeOfAccount : '',
                  purposeOfAccountOthers: productData?.purposeOfAccountOthers ? productData.purposeOfAccountOthers : '',
                  expectedUsage: productData?.expectedUsage ? productData.expectedUsage : '',
                },
              },
            );
          }
        }
      } else {
        const personalData = this.personalReviewData?.secondaryApplicantsPersonalInformation[0];

        this.secondaryApplicantsData = Object.assign(
          {},
          {
            ...this.secondaryApplicantsData,
            ...{
              expectedTurnover: personalData?.expectedTurnover,
              sourceOfFunds: personalData?.sourceCountryOfFundsDescription,
              jobReadOnly: personalData?.jobDescription,
              udfBusinessTypeReadOnly: personalData?.udfBusinessTypeDescription,
            },
          },
        );
        // assigning edit field values.
        this.editEnable('complianceDetails', 1);
        this.secondaryFormData = Object.assign(
          {},
          {
            ...this.secondaryFormData,
            ...{
              sourceCountryOfFunds: personalData?.sourceCountryOfFunds ? personalData.sourceCountryOfFunds : '',
              job: personalData?.job ? personalData.job : '',
              udfBusinessType: personalData?.udfBusinessType ? personalData.udfBusinessType : '',
              expectedTurnover: personalData?.expectedTurnover ? personalData.expectedTurnover : '',
            },
          },
        );
      }
    },
    async reviewScreenData() {
      this.productType = this.$route.params.productType;
      this.productsAllowedWithAccountDetails = !!this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.$route.params.productType);
      this.productData = store.getters['userStore/userData']?.productInfo;
      this.isLisa = this.getProductType === 'lifetimeISA';

      const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
      const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

      this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const b2bSessionId = reviewMappingData?.b2bSessionId;
      const status = await CommonService.addressLookup(urlObj.addressLookup, { postCode: 'ln119hf', b2bSessionId: b2bSessionId }, false);

      this.contactReviewData = JSON.parse(reviewMappingData.contactInformation);
      this.productInformation = JSON.parse(reviewMappingData.productInformation);
      this.personalReviewData = JSON.parse(reviewMappingData.personalInformation);
      this.taxReviewData = JSON.parse(reviewMappingData.taxInformation);
      this.accountInfoData = JSON.parse(reviewMappingData.accountInformation);
      this.otherInformation = JSON.parse(reviewMappingData.otherInformation);

      this.getUploadedDocuments(reviewMappingData, 'Primary');
      this.applicationNumber = reviewMappingData.applicationNumber;
      this.entityId = reviewMappingData.entityId;
      this.mobileNumber = reviewMappingData.mobileCountryCode + ' ' + reviewMappingData.mobilePhoneNumber;
      this.emailId = reviewMappingData.emailId;
      this.isAddressLookupEnabled = status && status?.data?.isAddressLookupEnabled ? 'true' : 'false';
      this.readOnlyAccountOwnership = this.productInformation.accountOwnership;

      await this.addressInformationData(0);
      await this.personalInformationData(0);
      await this.taxInformationData(0);
      await this.accountInformationData(0);
      this.employmentInformationData(0);
      this.udfInformationData(0, undefined, true);
      this.accountOwnerShipData();

      if ((this.getProductType === 'savings' || this.getProductType === 'termDeposit') && this.productInformation?.accountOwnership === 'JOINT') {
        this.secondaryReviewScreenData();
      }
      if (this.currentActionRoute !== 'ReviewInformation' && this.birthCountry !== '' && this.birthCountry !== null && this.birthCountry !== undefined) {
        router.push({ params: { action: 'ReviewInformation' } });
        window.scrollTo(0, 0);
      }
    },
    async secondaryReviewScreenData() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;

      this.secondaryApplicantsData = Object.assign(
        {},
        {
          ...this.secondaryApplicantsData,
          ...{
            mobileNumber: this.personalReviewData.secondaryApplicantsPersonalInformation[0].secondaryApplicantsMobileCountryCode + ' ' + this.personalReviewData.secondaryApplicantsPersonalInformation[0].secondaryApplicantsMobilePhoneNumber,
            emailId: this.personalReviewData.secondaryApplicantsPersonalInformation[0].secondaryApplicantsEmailId,
            relationshipTypeDescription: this.otherInformation.secondaryApplicantsOtherInformation[0].relationshipTypeDescription,
            relationshipType: this.otherInformation.secondaryApplicantsOtherInformation[0].relationshipType,
          },
        },
      );
      await this.getUploadedDocuments(reviewMappingData, 'Secondary');
      await this.addressInformationData(1);
      await this.personalInformationData(1);
      await this.taxInformationData(1);
      this.employmentInformationData(1);
      this.udfInformationData(1);
      this.secondaryFormData.relationshipTypeDescription = this.otherInformation.secondaryApplicantsOtherInformation[0].relationshipTypeDescription;
      this.secondaryFormData.relationshipType = this.otherInformation.secondaryApplicantsOtherInformation[0].relationshipType;
    },
    enableSaveButton(sectionName) {
      const mandatoryFields = [];

      Object.entries(this.reviewInformation).forEach(([key, value]) => {
        if (value && value.length > 0) {
          value.forEach((element) => {
            if (key === 'manualInputOfAddress' && value && value?.length > 1) {
              // eslint-disable-next-line no-unused-expressions
              Object.values(element).forEach((subElement) => {
                subElement.forEach((childElement) => {
                  if (childElement && childElement?.required && childElement?.enabledProducts.includes(this.getProductType)) {
                    mandatoryFields.push(childElement.key);
                  }
                });
              });
            } else {
              if (element && element.required && element.key !== 'addressLookup' && element?.enabledProducts.includes(this.getProductType)) {
                mandatoryFields.push(element.key);
              }
            }
          });
        }
      });
      switch (sectionName) {
        case 'addressDetails': {
          let contactListOfData = ['addressLine1', 'addressLine2', 'postCode', 'city', 'country', 'stateOrprovince'];
          contactListOfData = mandatoryFields.filter((field) => contactListOfData.includes(field));
          //  this if/else loop is to check if address details are filled based on when address lookup is enabled and disabled cases.
          if (this.tab === 1 && this.addressSameAsPrimary) {
            this.enableAddressSave = false;
          } else {
            const addressLookupEnabled = this.tab === 0 ? !this.addressAddedManually : !this.secondaryAddressAddedManually;

            if ((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && addressLookupEnabled) {
              const addressLookup = this.reviewInformation?.addressLookup[0];

              if (this.tab === 0) {
                const primary = addressLookup.enabledForPrimaryAddress.includes(this.getProductType) && this.isValueValid(this.residentialAddress);
                const correspondence = addressLookup.enabledForCorrespondenceAddress.includes(this.getProductType)
                  ? this.reviewCorresponding || (!this.reviewCorresponding && this.isValueValid(this.correspondenceAddress)) : true;
                const previousAddress = addressLookup.enabledForPreviousResidentialAddress.includes(this.getProductType) ? this.selected || (!this.selected && this.isValueValid(this.fromDate) && this.isValueValid(this.toDate) && this.isValueValid(this.previousResidentialAddress)) : true;

                if (primary && correspondence && previousAddress) {
                  this.enableAddressSave = false;
                } else {
                  this.enableAddressSave = true;
                }
              } else if (this.tab === 1) {
                const primary = addressLookup.enabledForPrimaryAddress.includes(this.getProductType) && this.isValueValid(this.secondaryResidentialAddress);
                const correspondence = addressLookup.enabledForCorrespondenceAddress.includes(this.getProductType)
                  ? this.secondaryReviewCorresponding || (!this.secondaryReviewCorresponding && this.isValueValid(this.secondaryCorrespondenceAddress)) : true;
                const previousAddress = addressLookup.enabledForPreviousResidentialAddress.includes(this.getProductType) ? this.secondarySelected || (!this.selected && this.isValueValid(this.fromDate) && this.isValueValid(this.toDate) && this.isValueValid(this.secondaryPreviousResidentialAddress)) : true;

                if (primary && correspondence && previousAddress) {
                  this.enableAddressSave = false;
                } else {
                  this.enableAddressSave = true;
                }
              }
            } else {
              const applicantTab = this.tab === 0 ? 'formData' : 'secondaryFormData';
              const correspondenceKey = this.tab === 0 ? 'manualInputCorresponding' : 'secondaryManualInputCorresponding';
              const previousAddressKey = this.tab === 0 ? 'prevManualAddress' : 'secondaryPrevManualAddress';
              const validContactDetails = /^[A-Za-z0-9\s]*$/.test(this[applicantTab]?.primaryAddress?.postCode) && this[applicantTab]?.primaryAddress &&

              this[applicantTab]?.primaryAddress?.postCode?.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength &&
              /^[a-zA-Z0-9,.*#"'&()/\s-]*$]*$/.test(this[applicantTab]?.primaryAddress?.addressLine1) && /^[a-zA-Z]*$/.test(this[applicantTab]?.primaryAddress?.city) && this[applicantTab]?.primaryAddress?.city?.length <= 50 &&
              (this[correspondenceKey] || (!this[correspondenceKey] && /^[A-Za-z0-9\s]*$/.test(this[applicantTab]?.correspondenceAddress?.postCode) && this[applicantTab]?.correspondenceAddress &&
              this[applicantTab]?.correspondenceAddress?.postCode?.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength &&
              /^[a-zA-Z0-9,.*#"'&()/\s-]*$]*$/.test(this[applicantTab]?.correspondenceAddress?.addressLine1) && /^[a-zA-Z]*$/.test(this[applicantTab]?.correspondenceAddress?.city) && this[applicantTab]?.correspondenceAddress?.city?.length <= 50)) &&
              (this[previousAddressKey] || (!this[previousAddressKey] && /^[A-Za-z0-9\s]*$/.test(this[applicantTab]?.previousResidentialAddress?.postCode) && this[applicantTab]?.previousResidentialAddress &&
              this[applicantTab]?.previousResidentialAddress?.postCode?.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength &&
              /^[a-zA-Z0-9,.*#"'&()/\s-]*$]*$/.test(this[applicantTab]?.previousResidentialAddress?.addressLine1) && /^[a-zA-Z]*$/.test(this[applicantTab]?.previousResidentialAddress?.city) && this[applicantTab]?.previousResidentialAddress?.city?.length <= 50));

              if (validContactDetails && this.checkPreFilledDataCount(contactListOfData, this[applicantTab].primaryAddress) === 0 && (this[correspondenceKey] ||
            (!this[correspondenceKey] && this[applicantTab]?.correspondenceAddress?.postCode.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength && this.checkPreFilledDataCount(contactListOfData, this[applicantTab].correspondenceAddress) === 0)
              ) && (this[previousAddressKey] || (!this[previousAddressKey] && this[applicantTab]?.previousResidentialAddress?.postCode.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength && this.checkPreFilledDataCount(contactListOfData, this[applicantTab].previousResidentialAddress) === 0))) {
                this.enableAddressSave = false;
              } else {
                this.enableAddressSave = true;
              }
            }
          }
          return this.enableAddressSave;
        }
        case 'personalDetails': {
          let personalListData = ['titleCode', 'firstName', 'middleName', 'lastName', 'gender', 'birthCountryCode', 'year', 'month', 'date', 'nationalIdTypeId', 'nationalIdNumber'];

          const applicantTab = this.tab === 0 ? 'formData' : 'secondaryFormData';

          personalListData = mandatoryFields.filter((field) => personalListData.includes(field));
          personalListData = ((this.tab === 0 && this.reviewMiddleNameCheckbox) || (this.tab === 1 && this.secondaryApplicantsData.reviewMiddleNameCheckbox)) && personalListData.includes('middleName') ? personalListData : personalListData.filter((field) => field !== 'middleName');
          const validPersonalDetails = new RegExp(this.reviewInformation.regxPattern[0].personalRegxPattern).test(this[applicantTab].firstName) && this[applicantTab]?.firstName?.length <= this.reviewInformation?.personalDetails[1]?.maxLength && ((this[applicantTab].lastName !== '' && new RegExp(this.reviewInformation.regxPattern[0].personalRegxPattern).test(this[applicantTab]?.lastName) && this[applicantTab]?.lastName?.length <= this.reviewInformation?.personalDetails[4]?.maxLength) || this[applicantTab]?.lastName === '') && ((this[applicantTab].middleName !== '' && new RegExp(this.reviewInformation.regxPattern[0].personalRegxPattern).test(this[applicantTab]?.middleName) && this[applicantTab]?.middleName?.length <= this.reviewInformation?.personalDetails[3]?.maxLength) || this[applicantTab]?.middleName === '' || this[applicantTab]?.middleName === undefined || this[applicantTab]?.middleName === null);
          const personalDetailsFilled = this.checkPreFilledDataCount(personalListData, this[applicantTab]) === 0 && validPersonalDetails;

          if (personalDetailsFilled) {
            this.enablePersonalSave = false;
          } else {
            this.enablePersonalSave = true;
          }
          return this.enablePersonalSave;
        }
        case 'taxDetails': {
          const applicantTab = this.tab === 0 ? 'formData' : 'secondaryFormData';
          const validNINONumber = /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])\d{6}([A-D])$/.test(this[applicantTab]?.taxIdentificationNumber);
          const taxResidentInOtherCountry = this.tab === 0 ? this.taxResidentInOtherCountry : this.secondaryTaxResidentInOtherCountry;
          const taxPayer = this.tab === 0 ? this.taxValue : this.secondaryTaxValue;
          let taxListData = ['taxIdentificationNumber', 'countryOfTaxResidentCode'];
          let taxPayerInOtherCountryListData = ['tinNumberInOtherCountry', 'foreignCountryOfTaxResidence'];

          taxListData = mandatoryFields.filter((field) => taxListData.includes(field));
          taxPayerInOtherCountryListData = mandatoryFields.filter((field) => taxPayerInOtherCountryListData.includes(field));

          const taxDetailsFilled = (this.tab === 0 && this.taxValue) || (this.tab === 1 && this.secondaryTaxValue) ? this.checkPreFilledDataCount(taxListData, this[applicantTab]) === 0 && validNINONumber && (!taxResidentInOtherCountry || (
            taxResidentInOtherCountry && this.checkPreFilledDataCount(taxPayerInOtherCountryListData, this[applicantTab]) === 0)) : (!taxPayer &&
            this.isValueValid(this[applicantTab].taxExemptionReason));

          if (taxDetailsFilled) {
            this.enableTaxSave = false;
          } else {
            this.enableTaxSave = true;
          }
          return this.enableTaxSave;
        }
        case 'employmentDetails': {
          const applicantTab = this.tab === 0 ? 'formData' : 'secondaryFormData';

          let employmentDetails = ['employmentStatus', 'nameOfTheEmployer', 'employmentType', 'businessType', 'jobTitle', 'paymentMethod', 'paymentFrequency'];
          employmentDetails = this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(this[applicantTab].employmentStatus) ? mandatoryFields.filter((field) => employmentDetails.includes(field)) : ['employmentStatus'];
          const employmentModifiedDetails = [];

          for (let index = 0; index < this.reviewInformation.employmentDetails.length; index++) {
            if ((this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(this[applicantTab].employmentStatus) && this.reviewInformation.employmentDetails[index].enableComponent && this.reviewInformation.employmentDetails[index].required &&
              (this[applicantTab][this.reviewInformation.employmentDetails[index].key] !== undefined && this[applicantTab][this.reviewInformation.employmentDetails[index].key] !== null && this[applicantTab][this.reviewInformation.employmentDetails[index].key] !== ''))) {
              employmentModifiedDetails.push(this.reviewInformation.employmentDetails[index].key);
            } else if ((!this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(this[applicantTab].employmentStatus))) {
              employmentModifiedDetails.push('employmentStatus');
              break;
            }
          }
          if (employmentDetails?.length === employmentModifiedDetails?.length) {
            this.enableEmploymentSave = false;
          } else {
            this.enableEmploymentSave = true;
          }
          return this.enableEmploymentSave;
        }
        case 'accountDetails': {
          if (this.reviewInformation && this.reviewInformation.accountDetails && this.reviewInformation.accountDetails.required.includes(this.getProductType)) {
            const accountDetailsFilled = this.ibanValue ? this.isValueValid(this.bicCode) && this.finalCurrency === 'EUR' : this.isValueValid(this.accountNumber) && this.isValueValid(this.sortCodeFinal) && this.isValueValid(this.finalBankName) && this.finalCurrency === 'GBP';

            if (accountDetailsFilled) {
              this.enableAccountSave = false;
            } else {
              this.enableAccountSave = true;
            }
          } else {
            this.enableAccountSave = false;
          }
          return this.enableAccountSave;
        }
        case 'complianceDetails': {
          const applicantTab = this.tab === 0 ? 'formData' : 'secondaryFormData';
          let complianceListOfData = ['expectedTurnover', 'sourceCountryOfFunds', 'job', 'udfBusinessType'];

          complianceListOfData = mandatoryFields.filter((field) => complianceListOfData.includes(field));
          const validComplianceDetails = complianceListOfData.includes('expectedTurnover') && this[applicantTab]?.expectedTurnover !== undefined && this[applicantTab]?.expectedTurnover !== null && this[applicantTab]?.expectedTurnover !== '' ? /^\d+(\.\d{1,2})?$/.test(this[applicantTab]?.expectedTurnover) : true;
          const complianceFilledData = this.checkPreFilledDataCount(complianceListOfData, this[applicantTab]) === 0;

          if (complianceFilledData && validComplianceDetails) {
            this.enableComplianceSave = false;
          } else {
            this.enableComplianceSave = true;
          }
          return this.enableComplianceSave;
        }
        case 'udfProductDetails': {
          let productListOfData = this.formData && this.formData.purposeOfAccount === 'ACCPURPOSE7' ? ['purposeOfAccount', 'purposeOfAccountOthers', 'expectedUsage'] : ['purposeOfAccount', 'expectedUsage'];

          productListOfData = mandatoryFields.filter((field) => productListOfData.includes(field) && this.$appSettings.dcoConfigurations.productLevelUdfConfiguration.includes(this.getProductType));
          const productFilledData = this.checkPreFilledDataCount(productListOfData, this.formData) === 0;

          if (productFilledData) {
            this.enableUdfProductSave = false;
          } else {
            this.enableUdfProductSave = true;
          }
          return this.enableUdfProductSave;
        }
        case 'relationshipTypeDetails': {
          const relationshipType = mandatoryFields.includes('relationshipType') ? this.isValueValid(this.secondaryFormData?.relationshipType) : true;

          if (relationshipType) {
            return false;
          } else {
            return true;
          }
        }
        default: console.log('Invalid Section Name');
      }
    },
    editEnable(sectionName, tab) {
      this.additionalNominatedData = this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType);
      let reviewMappingsData = store.getters['userStore/userData']?.additionalInfoData;
      const tabWiseFormData = tab === 0 ? 'formData' : 'secondaryFormData';

      if (tab === 1) {
        const contactReviewData = JSON.parse(reviewMappingsData.contactInformation)?.secondaryApplicantsContactInformation[0];
        const personalReviewData = JSON.parse(reviewMappingsData.personalInformation)?.secondaryApplicantsPersonalInformation[0];
        const taxReviewData = JSON.parse(reviewMappingsData.taxInformation)?.secondaryApplicantsTaxInformation[0];
        const otherInformation = JSON.parse(reviewMappingsData.otherInformation)?.secondaryApplicantsOtherInformation[0];

        reviewMappingsData = {
          contactInformation: JSON.stringify(contactReviewData),
          personalInformation: JSON.stringify(personalReviewData),
          taxInformation: JSON.stringify(taxReviewData),
          otherInformation: JSON.stringify(otherInformation),
          productInformation: reviewMappingsData?.productInformation,
        };
      }

      for (const data in this.reviewInformation) {
        if (data !== 'addressLookup' && (data === 'jointAccountDetails' || data === 'personalDetails' || data === 'taxDetails' || data === 'employmentDetails' || data === 'complianceDetails' || data === 'productEditDetails')) {
          this.reviewInformation[data].forEach((element) => {
            if (element.mapValue) {
              const value = data === 'employmentDetails' ? 'otherInformation' : element.mapValue.slice(1, -1);
              let assignValue = JSON.parse(reviewMappingsData[value]);
              assignValue = data === 'employmentDetails' ? assignValue.employmentDetails : assignValue;
              if (data !== 'manualInputOfAddress' && (data === sectionName || data === 'jointAccountDetails')) {
                this[tabWiseFormData][element.key] = element?.nestedValue && assignValue[element.nestedValue][element.key] ? JSON.parse(JSON.stringify(assignValue[element.nestedValue][element.key])) : assignValue[element.key];
              } else if (data !== 'manualInputOfAddress' && (!this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'false') && data === sectionName) {
                this[tabWiseFormData][element.key] = element?.nestedValue && assignValue[element.nestedValue][element.key] ? JSON.parse(JSON.stringify(assignValue[element.nestedValue][element.key])) : assignValue[element.key];
              }
            }
          });
        }
      }
      this.fileComponent = this.filename === 'Upload Statement Proof';
      this.$forceUpdate();
    },
    async editSaveChanges(editedSectionData, readonlyKey) {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const contactReviewData = JSON.parse(reviewMappingData.contactInformation);
      const personalReviewData = JSON.parse(reviewMappingData.personalInformation);
      const productReviewData = JSON.parse(reviewMappingData.productInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const otherInfo = JSON.parse(reviewMappingData.otherInformation);

      let contactInformation, personalInformation, productInformation, taxInformation;

      if (this.formData?.expectedTurnover !== undefined && this.formData?.expectedTurnover !== null && this.formData?.expectedTurnover !== '' && !(/^\d+(\.\d{1,2})?$/.test(this.formData?.expectedTurnover))) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.invalidFormatError'), type: 'error' });
      } else {
        if (editedSectionData === 'addressInformation') {
          contactInformation = await this.payload('addressInformation', contactReviewData);
        } else if (editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation') {
          personalInformation = JSON.stringify(await this.payload(editedSectionData, personalReviewData));
        } else if (editedSectionData === 'accountInformation') {
          this.accountInformation = await this.payload(editedSectionData);
        } else if (editedSectionData === 'taxInformation') {
          // taxInformation mapping
          taxInformation = JSON.stringify(await this.payload(editedSectionData));
        }
        const employmentDetails = {
          employmentStatus: this.formData.employmentStatus,
          nameOfTheEmployer: this.formData.nameOfTheEmployer,
          employmentType: this.formData.employmentType,
          businessType: this.formData.businessType,
          jobTitle: this.formData.jobTitle,
          paymentMethod: this.formData.paymentMethod,
          paymentFrequency: this.formData.paymentFrequency,
          employmentStatusDescription: this.formData?.employmentStatusDescription ? this.formData?.employmentStatusDescription : '',
          employmentTypeDescription: this.formData?.employmentTypeDescription ? this.formData?.employmentTypeDescription : '',
          businessTypeDescription: this.formData?.businessTypeDescription ? this.formData?.businessTypeDescription : '',
          jobTitleDescription: this.formData?.jobTitleDescription ? this.formData?.jobTitleDescription : '',
          paymentMethodDescription: this.formData?.paymentMethodDescription ? this.formData?.paymentMethodDescription : '',
          paymentFrequencyDescription: this.formData?.paymentFrequencyDescription ? this.formData?.paymentFrequencyDescription : '',
        };

        const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
        const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

        this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';

        // product information mapping
        productInformation = JSON.stringify({
          productTypeCode: this.apiProductType,
          productId: productMapping.data.productCode,
          accountOwnership: this.accountOwnership,
          modeOfOperation: this.modeOfOperation,
          tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
          tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
          interestRate: '',
          postingRestriction: '',
          currencyCode: productMapping.data.currencyCode,
          maturityInstruction: '',
          purposeOfAccount: this.formData?.purposeOfAccount !== undefined && this.formData?.purposeOfAccount !== '' ? this.formData?.purposeOfAccount : productReviewData?.purposeOfAccount || '',
          purposeOfAccountOthers: this.formData?.purposeOfAccountOthers !== undefined && this.formData?.purposeOfAccountOthers !== '' ? this.formData?.purposeOfAccountOthers : productReviewData?.purposeOfAccountOthers || '',
          expectedUsage: this.formData?.expectedUsage !== undefined && this.formData?.expectedUsage !== '' ? this.formData?.expectedUsage : productReviewData?.expectedUsage || '',
          purposeOfAccountDescription: this.formData?.purposeOfAccountDescription !== undefined && this.formData?.purposeOfAccountDescription !== '' ? this.formData?.purposeOfAccountDescription : productReviewData?.purposeOfAccountDescription || '',
          expectedUsageDescription: this.formData?.expectedUsageDescription !== undefined && this.formData?.expectedUsageDescription !== '' ? this.formData?.expectedUsageDescription : productReviewData?.expectedUsageDescription || '',
          module: productMapping?.data.module,
          productEndDate: productMapping?.data?.productEndDate,
          isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
          productSubType: this.getProductType || '',
        });
        const data = {
          accountInformation: editedSectionData === 'accountInformation' ? this.accountInformation : reviewMappingData.accountInformation,
          activeFlag: reviewMappingData.activeFlag,
          activeFrom: reviewMappingData.activeFrom,
          activeTill: reviewMappingData.activeTill,
          applicationId: reviewMappingData.applicationId,
          applicationNumber: reviewMappingData.applicationNumber,
          applicationStatus: reviewMappingData.applicationStatus,
          createdBy: reviewMappingData.createdBy,
          createdDate: reviewMappingData.createdDate,
          customerId: reviewMappingData.customerId,
          deletedFlag: reviewMappingData.deletedFlag,
          documentInformation: reviewMappingData.documentInformation,
          emailId: reviewMappingData.emailId,
          entityId: reviewMappingData.entityId,
          lastModifiedBy: reviewMappingData.lastModifiedBy,
          lastModifiedDate: reviewMappingData.lastModifiedDate,
          mobileCountryCode: reviewMappingData.mobileCountryCode,
          mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
          personalInformation: editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation' ? personalInformation : reviewMappingData.personalInformation,
          productInformation: productInformation,
          contactInformation: editedSectionData === 'addressInformation' ? contactInformation : reviewMappingData.contactInformation,
          taxInformation: editedSectionData === 'taxInformation' ? taxInformation : reviewMappingData.taxInformation,
          otherInformation: {
            employmentDetails: editedSectionData === 'employmentInformation' ? employmentDetails : otherInfo?.employmentDetails,
            mobileNumberVerified: true,
            addressLookupEnabled: otherInfo && otherInfo?.addressLookupEnabled,
            lisaTransferInWithAgeValidation: this.getProductType === 'lifetimeISA' ? localStorage.getItem('isLisaTransferInWithAgeCheck') : otherInfo?.lisaTransferInWithAgeValidation },
          readOnlyFlag: reviewMappingData.readOnlyFlag,
          statusInformation: reviewMappingData.statusInformation,
          systemFlag: reviewMappingData.systemFlag,
          tenantId: reviewMappingData.tenantId,
          version: reviewMappingData.version,
          b2bSessionId: reviewMappingData.b2bSessionId,
        };
        const additionalInfoData = await CommonService.postData(urlObj.save, data);

        if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
          this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
        } else {
          store.dispatch('userStore/setUserData', { additionalInfoData });
          this.showUnsavedSnackbar(readonlyKey, true);
          window.scrollTo(0, 0);
          this.reviewScreenData();
        }
      }
    },
    async deleteSecondaryApplicantData() {
      const response = store.getters['userStore/userData']?.additionalInfoData; ;
      const personalInfoResponse = response && response.data ? response.data : response;
      const secondaryData = personalInfoResponse;
      const personalInformation = JSON.parse(secondaryData?.personalInformation);
      const taxInformation = JSON.parse(secondaryData?.taxInformation);
      const otherInformation = JSON.parse(secondaryData?.otherInformation);
      const contactInformation = JSON.parse(secondaryData?.contactInformation);
      let productInformation = JSON.parse(secondaryData?.productInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;

      delete personalInformation?.secondaryApplicantsPersonalInformation;
      delete taxInformation?.secondaryApplicantsTaxInformation;
      delete otherInformation?.secondaryApplicantsOtherInformation;
      delete contactInformation?.secondaryApplicantsContactInformation;

      const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
      const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

      this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';

      productInformation = JSON.stringify({
        productTypeCode: this.apiProductType.toLowerCase(),
        productId: this.getProductCode,
        accountOwnership: 'SOLE',
        modeOfOperation: 'SOLE',
        tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
        tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
        interestRate: '',
        postingRestriction: '',
        currencyCode: productInformation?.currencyCode,
        maturityInstruction: '',
        module: productMapping?.data.module,
        purposeOfAccount: productInformation?.purposeOfAccount || '',
        purposeOfAccountOthers: productInformation?.purposeOfAccountOthers || '',
        expectedUsage: productInformation?.expectedUsage || '',
        purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
        expectedUsageDescription: productInformation?.expectedUsageDescription || '',
        productEndDate: productMapping?.data?.productEndDate,
        isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
        productSubType: this.getProductType || '',
      });

      secondaryData.productInformation = productInformation;
      secondaryData.personalInformation = JSON.stringify(personalInformation);
      secondaryData.taxInformation = JSON.stringify(taxInformation);
      secondaryData.otherInformation = otherInformation;
      secondaryData.contactInformation = JSON.stringify(contactInformation);

      const additionalInfoData = await CommonService.postData(urlObj.save, secondaryData);

      if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
        this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
      } else {
        let imageDeleted = await CommonService.deleteUploadedFile(`${urlObj.upload}/${this.secondaryImageEntityId}`);
        for (let i = 0; i < this.secondaryApplicantsPicturesEntityId.length; i++) {
          imageDeleted = await CommonService.deleteUploadedFile(`${urlObj.upload}/${this.secondaryApplicantsPicturesEntityId[i]}`);
        }
        if (imageDeleted) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
          this.editAccountDetailsCheck = false;
          this.secondaryEditCheck = false;
          this.accountOwnershipModal = false;
          this.accountOwnerShipData();
          this.tab = 0;
          this.reviewScreenData();
        }
      }
    },
    async updateAccountOwnerShipDetails() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const productInformation = JSON.parse(reviewMappingData?.productInformation);
      const accountOwnershipChanged = this.accountOwnership !== productInformation?.accountOwnership;

      if (accountOwnershipChanged) {
        if (['SOLE', 'SINGLE'].includes(this.accountOwnership) && productInformation?.accountOwnership === 'JOINT') {
          this.secondaryDataErase = true;
        } else {
          this.secondaryCustomerOnboard = true;
        }
        this.accountOwnershipModal = true;
      } else {
        this.saveAccountOwnerShipDetails();
      }
      this.showUnsavedSnackbar();
    },
    async updateChangesWithSecondaryDetails(editedSectionData, readonlyKey) {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const contactReviewData = JSON.parse(reviewMappingData.contactInformation);
      const personalReviewData = JSON.parse(reviewMappingData.personalInformation);
      const taxReviewData = JSON.parse(reviewMappingData.taxInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const otherInfo = JSON.parse(reviewMappingData.otherInformation);
      const productReviewData = JSON.parse(reviewMappingData.productInformation);
      let contactInformation = '';
      let personalInformation, taxInformation, productInformation;

      if (this.formData?.expectedTurnover !== undefined && this.formData?.expectedTurnover !== null && this.formData?.expectedTurnover !== '' && !(/^\d+(\.\d{1,2})?$/.test(this.formData?.expectedTurnover))) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.invalidFormatError'), type: 'error' });
      } else {
        if (editedSectionData === 'addressInformation') {
          if ((this.isAddressLookupEnabled === 'true' && !this.addressAddedManually)) {
            if (contactReviewData?.primaryAddress?.addressID !== '' && this.mainAddressresponse === '' && this.isDefault === contactReviewData.primaryAddress.isDefault) {
              this.primaryAddress = contactReviewData.primaryAddress;
            } else if (this.mainAddressresponse === '' && this.isDefault !== contactReviewData.primaryAddress.isDefault) {
              this.primaryAddress = {
                postCode: contactReviewData?.primaryAddress?.postCode.split(' ').join('').toLowerCase(),
                addressID: contactReviewData?.primaryAddress?.addressID || '',
                buildingNumber: '',
                addressLine1: contactReviewData?.primaryAddress?.addressLine1 || '',
                addressLine2: contactReviewData?.primaryAddress?.addressLine2 || '',
                addressLine3: contactReviewData?.primaryAddress?.addressLine3 || '',
                addressLine4: contactReviewData?.primaryAddress?.addressLine4 || '',
                addressLine5: contactReviewData?.primaryAddress?.addressLine5 || '',
                addressLine6: contactReviewData?.primaryAddress?.addressLine6 || '',
                addressLine7: contactReviewData?.primaryAddress?.addressLine7 || '',
                addressLine8: contactReviewData?.primaryAddress?.addressLine8 || '',
                addressLine9: contactReviewData?.primaryAddress?.addressLine9 || '',
                addressLine10: contactReviewData?.primaryAddress?.addressLine10 || '',
                addressText: this.residentialAddress || '',
                city: contactReviewData?.primaryAddress?.city,
                stateOrprovince: contactReviewData?.primaryAddress?.stateOrprovince || '',
                stateOrprovinceName: contactReviewData?.primaryAddress?.stateOrprovince || '',
                country: contactReviewData?.primaryAddress?.country,
                isDefault: (this.isDefault === true),
              };
            } else {
              this.primaryAddress = {
                postCode: this.mainAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                addressID: this.mainAddressresponse.data?.addressId || '',
                buildingNumber: '',
                addressLine1: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine1 || ''),
                addressLine2: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine2 || ''),
                addressLine3: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine3 || ''),
                addressLine4: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine4 || ''),
                addressLine5: this.mainAddressresponse.data?.addressLine5 || '',
                addressLine6: this.mainAddressresponse.data?.addressLine6 || '',
                addressLine7: this.mainAddressresponse.data?.addressLine7 || '',
                addressLine8: this.mainAddressresponse.data?.addressLine8 || '',
                addressLine9: this.mainAddressresponse.data?.addressLine9 || '',
                addressLine10: this.mainAddressresponse.data?.addressLine10 || '',
                addressText: this.residentialAddress || '',
                city: this.mainAddressresponse.data.city,
                stateOrprovince: this.mainAddressresponse.data?.region || '',
                stateOrprovinceName: this.mainAddressresponse.data?.region || '',
                country: this.mainAddressresponse.data.countryCode,
                isDefault: (this.isDefault === true),
              };
            }
            if (this.reviewCorresponding === true) {
              this.correspondingAddress = {
                postCode: this.primaryAddress.postCode.split(' ').join('').toLowerCase(),
                addressID: this.primaryAddress?.addressID || '',
                buildingNumber: '',
                addressLine1: this.primaryAddress?.addressLine1 || '',
                addressLine2: this.primaryAddress?.addressLine2 || '',
                addressLine3: this.primaryAddress?.addressLine3 || '',
                addressLine4: this.primaryAddress?.addressLine4 || '',
                addressLine5: this.primaryAddress?.addressLine5 || '',
                addressLine6: this.primaryAddress?.addressLine6 || '',
                addressLine7: this.primaryAddress?.addressLine7 || '',
                addressLine8: this.primaryAddress?.addressLine8 || '',
                addressLine9: this.primaryAddress?.addressLine9 || '',
                addressLine10: this.primaryAddress?.addressLine10 || '',
                addressText: this.residentialAddress || '',
                city: this.primaryAddress?.city,
                stateOrprovince: this.primaryAddress?.stateOrprovince || '',
                stateOrprovinceName: this.primaryAddress?.stateOrprovince || '',
                country: this.primaryAddress?.country,
                isDefault: (this.isDefault === false),
              };
              this.correspondenceAddress = '';
              this.corrAddressresponse = '';
            } else if (this.reviewCorresponding === false) {
              if (contactReviewData?.correspondenceAddress?.addressID !== '' && this.corrAddressresponse === '') {
                this.correspondingAddress = {
                  postCode: contactReviewData?.correspondenceAddress?.postCode.split(' ').join('').toLowerCase(),
                  addressID: contactReviewData?.correspondenceAddress?.addressID,
                  buildingNumber: null,
                  addressLine1: contactReviewData?.correspondenceAddress?.addressLine1 || '',
                  addressLine2: contactReviewData?.correspondenceAddress?.addressLine2 || '',
                  addressLine3: contactReviewData?.correspondenceAddress?.addressLine3 || '',
                  addressLine4: contactReviewData?.correspondenceAddress?.addressLine4 || '',
                  addressLine5: contactReviewData?.correspondenceAddress?.addressLine5 || '',
                  addressLine6: contactReviewData?.correspondenceAddress?.addressLine6 || '',
                  addressLine7: contactReviewData?.correspondenceAddress?.addressLine7 || '',
                  addressLine8: contactReviewData?.correspondenceAddress?.addressLine8 || '',
                  addressLine9: contactReviewData?.correspondenceAddress?.addressLine9 || '',
                  addressLine10: contactReviewData?.correspondenceAddress?.addressLine10 || '',
                  addressText: contactReviewData?.correspondenceAddress?.addressText || '',
                  city: contactReviewData?.correspondenceAddress?.city,
                  stateOrprovince: contactReviewData?.correspondenceAddress?.stateOrprovince || '',
                  stateOrprovinceName: contactReviewData?.correspondenceAddress?.stateOrprovince || '',
                  country: contactReviewData?.correspondenceAddress?.country,
                  isDefault: (this.isDefault === false),
                };
              } else {
                this.correspondingAddress = {
                  postCode: this.corrAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                  addressID: this.corrAddressresponse.data?.addressId,
                  buildingNumber: null,
                  addressLine1: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine1 || ''),
                  addressLine2: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine2 || ''),
                  addressLine3: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine3 || ''),
                  addressLine4: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine4 || ''),
                  addressLine5: this.corrAddressresponse.data?.addressLine5 || '',
                  addressLine6: this.corrAddressresponse.data?.addressLine6 || '',
                  addressLine7: this.corrAddressresponse.data?.addressLine7 || '',
                  addressLine8: this.corrAddressresponse.data?.addressLine8 || '',
                  addressLine9: this.corrAddressresponse.data?.addressLine9 || '',
                  addressLine10: this.corrAddressresponse.data?.addressLine10 || '',
                  addressText: this.correspondenceAddress || '',
                  city: this.corrAddressresponse.data?.city,
                  stateOrprovince: this.corrAddressresponse.data?.region || '',
                  stateOrprovinceName: this.corrAddressresponse.data?.region || '',
                  country: this.corrAddressresponse.data.countryCode,
                  isDefault: (this.isDefault === false),
                };
              }
            }
            if (this.selected === false) {
              if (contactReviewData?.previousResidentialAddress?.addressID !== '' && this.prevAddressresponse === '') {
                this.previousResidentialAddress = {
                  postCode: contactReviewData?.previousResidentialAddress?.postCode.split(' ').join('').toLowerCase(),
                  addressID: contactReviewData?.previousResidentialAddress?.addressID || '',
                  buildingNumber: null,
                  addressLine1: contactReviewData?.previousResidentialAddress?.addressLine1 || '',
                  addressLine2: contactReviewData?.previousResidentialAddress?.addressLine2 || '',
                  addressLine3: contactReviewData?.previousResidentialAddress?.addressLine3 || '',
                  addressLine4: contactReviewData?.previousResidentialAddress?.addressLine4 || '',
                  addressLine5: contactReviewData?.previousResidentialAddress?.addressLine5 || '',
                  addressLine6: contactReviewData?.previousResidentialAddress?.addressLine6 || '',
                  addressLine7: contactReviewData?.previousResidentialAddress?.addressLine7 || '',
                  addressLine8: contactReviewData?.previousResidentialAddress?.addressLine8 || '',
                  addressLine9: contactReviewData?.previousResidentialAddress?.addressLine9 || '',
                  addressLine10: contactReviewData?.previousResidentialAddress?.addressLine10 || '',
                  addressText: contactReviewData?.previousResidentialAddress?.addressText || '',
                  city: contactReviewData?.previousResidentialAddress?.city,
                  stateOrprovince: contactReviewData?.previousResidentialAddress?.stateOrprovince || '',
                  stateOrprovinceName: contactReviewData?.previousResidentialAddress?.stateOrprovince || '',
                  country: contactReviewData?.previousResidentialAddress?.country,
                  fromDate: contactReviewData?.previousResidentialAddress?.fromDate,
                  toDate: contactReviewData?.previousResidentialAddress?.toDate,
                };
              } else {
                this.previousResidentialAddress = {
                  postCode: this.prevAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                  addressID: this.prevAddressresponse.data?.addressId,
                  buildingNumber: null,
                  addressLine1: this.prevAddressresponse.data?.addressLine1 || '',
                  addressLine2: this.prevAddressresponse.data?.addressLine2 || '',
                  addressLine3: this.prevAddressresponse.data?.addressLine3 || '',
                  addressLine4: this.prevAddressresponse.data?.addressLine4 || '',
                  addressLine5: this.prevAddressresponse.data?.addressLine5 || '',
                  addressLine6: this.prevAddressresponse.data?.addressLine6 || '',
                  addressLine7: this.prevAddressresponse.data?.addressLine7 || '',
                  addressLine8: this.prevAddressresponse.data?.addressLine8 || '',
                  addressLine9: this.prevAddressresponse.data?.addressLine9 || '',
                  addressLine10: this.prevAddressresponse.data?.addressLine10 || '',
                  addressText: this.previousResidentialAddress || '',
                  city: this.prevAddressresponse.data?.city,
                  stateOrprovince: this.prevAddressresponse.data?.region || '',
                  stateOrprovinceName: this.prevAddressresponse.data?.region || '',
                  country: this.prevAddressresponse.data.countryCode,
                  fromDate: this.fromDate,
                  toDate: this.toDate,
                };
              }
            } else if (this.selected === true) {
              this.previousResidentialAddress = '';
              this.prevAddressresponse = '';
              this.fromDate = '';
              this.toDate = '';
            }
          } else if (this.isAddressLookupEnabled === 'false' || this.addressAddedManually) {
            this.primaryAddress = {
              postCode: this.formData.primaryAddress.postCode,
              addressID: '',
              buildingNumber: '',
              addressLine1: this.formData.primaryAddress.addressLine1,
              addressLine2: this.formData.primaryAddress.addressLine2 || '',
              addressLine3: this.addPrimaryAddressLine3 ? this.formData.primaryAddress.addressLine3 : '',
              addressLine4: this.addPrimaryAddressLine4 ? this.formData.primaryAddress.addressLine4 : '',
              city: this.formData.primaryAddress.city,
              stateOrprovince: this.formData.primaryAddress.stateOrprovince,
              country: this.formData.primaryAddress.country,
              stateOrprovinceName: this.formData?.primaryStateDescription ?? contactReviewData?.primaryAddress?.stateOrprovinceName,
              countryName: this.isValueValid(this.formData?.primaryCountryDescription) ? this.formData?.primaryCountryDescription : contactReviewData?.primaryAddress?.countryName,
              isDefault: (this.isDefaultManual === true),
            };
            if (this.manualInputCorresponding === true) {
              this.correspondingAddress = {
                postCode: this.formData.primaryAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.formData.primaryAddress.addressLine1,
                addressLine2: this.formData.primaryAddress.addressLine2 || '',
                addressLine3: this.addPrimaryAddressLine3 ? this.formData.primaryAddress.addressLine3 : '',
                addressLine4: this.addPrimaryAddressLine3 && this.addPrimaryAddressLine4 ? this.formData.primaryAddress.addressLine4 : '',
                city: this.formData.primaryAddress.city,
                stateOrprovince: this.formData.primaryAddress.stateOrprovince,
                stateOrprovinceName: this.formData?.primaryStateDescription ?? contactReviewData?.primaryAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.formData?.primaryCountryDescription) ? this.formData?.primaryCountryDescription : contactReviewData?.primaryAddress?.countryName,
                country: this.formData.primaryAddress.country,
                isDefault: (this.isDefaultManual === false),
              };
            } else if (this.manualInputCorresponding === false) {
              this.correspondingAddress = {
                postCode: this.formData.correspondenceAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.formData.correspondenceAddress.addressLine1,
                addressLine2: this.formData.correspondenceAddress.addressLine2 || '',
                addressLine3: this.addcorrAddressLine3 ? this.formData.correspondenceAddress.addressLine3 : '',
                addressLine4: this.addcorrAddressLine3 && this.addcorrAddressLine4 ? this.formData.correspondenceAddress.addressLine4 : '',
                city: this.formData.correspondenceAddress.city,
                stateOrprovince: this.formData.correspondenceAddress.stateOrprovince,
                country: this.formData.correspondenceAddress.country,
                stateOrprovinceName: this.formData?.correspondenceStateDescription ?? contactReviewData?.correspondenceAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.formData?.correspondenceCountryDescription) ? this.formData?.correspondenceCountryDescription : contactReviewData?.correspondenceAddress?.countryName,
                isDefault: (this.isDefaultManual === false),
              };
            }
            if (this.prevManualAddress === false) {
              this.previousResidentialAddress = {
                postCode: this.formData.previousResidentialAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.formData.previousResidentialAddress.addressLine1,
                addressLine2: this.formData.previousResidentialAddress.addressLine2 || '',
                addressLine3: this.addprevAddressLine3 ? this.formData.previousResidentialAddress.addressLine3 : '',
                addressLine4: this.addprevAddressLine3 && this.addprevAddressLine4 ? this.formData.previousResidentialAddress.addressLine4 : '',
                city: this.formData.previousResidentialAddress.city,
                stateOrprovince: this.formData.previousResidentialAddress.stateOrprovince,
                country: this.formData.previousResidentialAddress.country,
                stateOrprovinceName: this.formData?.previousStateDescription ?? contactReviewData?.previousResidentialAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.formData?.previousCountryDescription) ? this.formData?.previousCountryDescription : contactReviewData?.previousResidentialAddress?.countryName,
                fromDate: this.formData.previousResidentialAddress.fromDate || this.fromDate,
                toDate: this.formData.previousResidentialAddress.toDate || this.toDate,
              };
            }
          }
          if (this.addressSameAsPrimary) {
            if (((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && !this.addressAddedManually && this.selected === false) || (this.addressAddedManually && this.prevManualAddress === false)) {
              contactInformation = JSON.stringify({ primaryAddress: this.primaryAddress,
                correspondenceAddress: this.correspondingAddress,
                previousResidentialAddress: this.previousResidentialAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: this.primaryAddress,
                  correspondenceAddress: this.correspondingAddress,
                  previousResidentialAddress: this.previousResidentialAddress,
                }] });
            } else if (this.correspondingAddress !== '' && this.correspondingAddress !== null) {
              contactInformation = JSON.stringify({
                primaryAddress: this.primaryAddress,
                correspondenceAddress: this.correspondingAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: this.primaryAddress,
                  correspondenceAddress: this.correspondingAddress,
                }],
              });
            } else {
              contactInformation = JSON.stringify({ primaryAddress: this.primaryAddress, secondaryApplicantsContactInformation: this.primaryAddress });
            }
          } else {
            if ((this.isAddressLookupEnabled === 'true' && !this.addressAddedManually && this.selected === false) || (this.addressAddedManually && this.prevManualAddress === false)) {
              contactInformation = JSON.stringify({ primaryAddress: this.primaryAddress,
                correspondenceAddress: this.correspondingAddress,
                previousResidentialAddress: this.previousResidentialAddress,
                secondaryApplicantsContactInformation: contactReviewData?.secondaryApplicantsContactInformation });
            } else if (this.correspondingAddress !== '' && this.correspondingAddress !== null) {
              contactInformation = JSON.stringify({
                primaryAddress: this.primaryAddress,
                correspondenceAddress: this.correspondingAddress,
                secondaryApplicantsContactInformation: contactReviewData?.secondaryApplicantsContactInformation,
              });
            } else {
              contactInformation = JSON.stringify({ primaryAddress: this.primaryAddress, secondaryApplicantsContactInformation: contactReviewData?.secondaryApplicantsContactInformation });
            }
          }
        } else if (editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation') {
          personalInformation = await this.payload(editedSectionData, personalReviewData);
          personalInformation = Object.assign(personalInformation, {
            secondaryApplicantsPersonalInformation: personalReviewData?.secondaryApplicantsPersonalInformation,
          });
          personalInformation = JSON.stringify(personalInformation);
        } else if (editedSectionData === 'taxInformation') {
          taxInformation = await this.payload(editedSectionData);
          taxInformation = Object.assign(taxInformation, {
            secondaryApplicantsTaxInformation: taxReviewData?.secondaryApplicantsTaxInformation,
          });
          taxInformation = JSON.stringify(taxInformation);
        } else if (editedSectionData === 'accountInformation' && this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType)) {
          this.accountInformation = await this.payload(editedSectionData);
        }
        const employmentDetails = {
          employmentStatus: this.formData.employmentStatus,
          nameOfTheEmployer: this.formData.nameOfTheEmployer,
          employmentType: this.formData.employmentType,
          businessType: this.formData.businessType,
          jobTitle: this.formData.jobTitle,
          paymentMethod: this.formData.paymentMethod,
          paymentFrequency: this.formData.paymentFrequency,
          employmentStatusDescription: this.formData?.employmentStatusDescription ? this.formData?.employmentStatusDescription : '',
          employmentTypeDescription: this.formData?.employmentTypeDescription ? this.formData?.employmentTypeDescription : '',
          businessTypeDescription: this.formData?.businessTypeDescription ? this.formData?.businessTypeDescription : '',
          jobTitleDescription: this.formData?.jobTitleDescription ? this.formData?.jobTitleDescription : '',
          paymentMethodDescription: this.formData?.paymentMethodDescription ? this.formData?.paymentMethodDescription : '',
          paymentFrequencyDescription: this.formData?.paymentFrequencyDescription ? this.formData?.paymentFrequencyDescription : '',
        };

        const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
        const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

        this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
        productInformation = JSON.stringify({
          productTypeCode: this.apiProductType,
          productId: productMapping.data.productCode,
          accountOwnership: this.accountOwnership,
          modeOfOperation: this.modeOfOperation,
          tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
          tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
          interestRate: '',
          postingRestriction: '',
          currencyCode: productMapping.data.currencyCode,
          maturityInstruction: '',
          module: productMapping.data.module,
          purposeOfAccount: this.formData.purposeOfAccount,
          purposeOfAccountOthers: this.formData.purposeOfAccountOthers,
          expectedUsage: this.formData.expectedUsage,
          purposeOfAccountDescription: this.formData.purposeOfAccountDescription ? this.formData.purposeOfAccountDescription : productReviewData?.purposeOfAccountDescription,
          expectedUsageDescription: this.formData.expectedUsageDescription ? this.formData.expectedUsageDescription : productReviewData?.expectedUsageDescription,
          productEndDate: productMapping?.data?.productEndDate,
          isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
          productSubType: this.getProductType || '',
        });
        const data = {
          accountInformation: editedSectionData === 'accountInformation' ? this.accountInformation : reviewMappingData?.accountInformation,
          activeFlag: reviewMappingData.activeFlag,
          activeFrom: reviewMappingData.activeFrom,
          activeTill: reviewMappingData.activeTill,
          applicationId: reviewMappingData.applicationId,
          applicationNumber: reviewMappingData.applicationNumber,
          applicationStatus: reviewMappingData.applicationStatus,
          createdBy: reviewMappingData.createdBy,
          createdDate: reviewMappingData.createdDate,
          customerId: reviewMappingData.customerId,
          deletedFlag: reviewMappingData.deletedFlag,
          documentInformation: reviewMappingData.documentInformation,
          emailId: reviewMappingData.emailId,
          entityId: reviewMappingData.entityId,
          lastModifiedBy: reviewMappingData.lastModifiedBy,
          lastModifiedDate: reviewMappingData.lastModifiedDate,
          mobileCountryCode: reviewMappingData.mobileCountryCode,
          mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
          personalInformation: editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation' ? personalInformation : reviewMappingData.personalInformation,
          productInformation: productInformation,
          contactInformation: editedSectionData === 'addressInformation' ? contactInformation : reviewMappingData?.contactInformation,
          taxInformation: editedSectionData === 'taxInformation' ? taxInformation : reviewMappingData?.taxInformation,
          otherInformation: {
            employmentDetails: editedSectionData === 'employmentInformation' ? employmentDetails : otherInfo?.employmentDetails,
            mobileNumberVerified: true,
            addressLookupEnabled: otherInfo && otherInfo?.addressLookupEnabled,
            lisaTransferInWithAgeValidation: this.getProductType === 'lifetimeISA' ? localStorage.getItem('isLisaTransferInWithAgeCheck') : otherInfo?.lisaTransferInWithAgeValidation,
            secondaryApplicantsOtherInformation: otherInfo?.secondaryApplicantsOtherInformation },
          readOnlyFlag: reviewMappingData.readOnlyFlag,
          statusInformation: reviewMappingData.statusInformation,
          systemFlag: reviewMappingData.systemFlag,
          tenantId: reviewMappingData.tenantId,
          version: reviewMappingData.version,
          b2bSessionId: reviewMappingData.b2bSessionId,
        };
        const additionalInfoData = await CommonService.postData(urlObj.save, data);

        if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
          this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
        } else {
          store.dispatch('userStore/setUserData', { additionalInfoData });
          this.showUnsavedSnackbar(readonlyKey, true);
          window.scrollTo(0, 0);
          this.reviewScreenData();
        }
      }
    },
    async updateChangesWithPrimaryDetails(editedSectionData, readonlyKey) {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const contactReviewData = JSON.parse(reviewMappingData.contactInformation)?.secondaryApplicantsContactInformation[0];
      const personalReviewData = JSON.parse(reviewMappingData.personalInformation)?.secondaryApplicantsPersonalInformation[0];
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const otherInfo = JSON.parse(reviewMappingData.otherInformation)?.secondaryApplicantsOtherInformation[0];
      const primaryContactData = JSON.parse(reviewMappingData.contactInformation);
      const primaryPersonalData = JSON.parse(reviewMappingData.personalInformation);
      const primaryProductData = JSON.parse(reviewMappingData.productInformation);
      const primaryTaxData = JSON.parse(reviewMappingData.taxInformation);
      const primaryOtherInfo = JSON.parse(reviewMappingData.otherInformation);

      let contactInformation = ''; let personalInformation; let taxInformation; let productInformation;

      if (this.secondaryFormData?.expectedTurnover !== undefined && this.secondaryFormData?.expectedTurnover !== null && this.secondaryFormData?.expectedTurnover !== '' && !(/^\d+(\.\d{1,2})?$/.test(this.secondaryFormData?.expectedTurnover))) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.invalidFormatError'), type: 'error' });
      } else {
        if (editedSectionData === 'addressInformation') {
          if ((this.isAddressLookupEnabled === 'true' && !this.secondaryAddressAddedManually)) {
            if (contactReviewData?.primaryAddress?.addressID !== '' && this.secondaryMainAddressresponse === '' && this.isDefaultSecondary === contactReviewData.primaryAddress.isDefault) {
              this.primaryAddress = contactReviewData.primaryAddress;
            } else if (this.secondaryMainAddressresponse === '' && this.isDefaultSecondary === true !== contactReviewData.primaryAddress.isDefault) {
              this.primaryAddress = {
                postCode: contactReviewData?.primaryAddress?.postCode.split(' ').join('').toLowerCase(),
                addressID: contactReviewData?.primaryAddress?.addressID || '',
                buildingNumber: '',
                addressLine1: contactReviewData?.primaryAddress?.addressLine1 || '',
                addressLine2: contactReviewData?.primaryAddress?.addressLine2 || '',
                addressLine3: contactReviewData?.primaryAddress?.addressLine3 || '',
                addressLine4: contactReviewData?.primaryAddress?.addressLine4 || '',
                addressLine5: contactReviewData?.primaryAddress?.addressLine5 || '',
                addressLine6: contactReviewData?.primaryAddress?.addressLine6 || '',
                addressLine7: contactReviewData?.primaryAddress?.addressLine7 || '',
                addressLine8: contactReviewData?.primaryAddress?.addressLine8 || '',
                addressLine9: contactReviewData?.primaryAddress?.addressLine9 || '',
                addressLine10: contactReviewData?.primaryAddress?.addressLine10 || '',
                addressText: contactReviewData?.primaryAddress?.addressText || '',
                city: contactReviewData?.primaryAddress?.city,
                stateOrprovince: contactReviewData?.primaryAddress?.stateOrprovince || '',
                stateOrprovinceName: contactReviewData?.primaryAddress?.stateOrprovince || '',
                country: contactReviewData?.primaryAddress?.country,
                isDefault: (this.isDefaultSecondary === true),
              };
            } else {
              this.primaryAddress = {
                postCode: this.secondaryMainAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                addressID: this.secondaryMainAddressresponse.data?.addressId || '',
                buildingNumber: '',
                addressLine1: this.decodeHtmlEntities(this.secondaryMainAddressresponse.data?.addressLine1 || ''),
                addressLine2: this.decodeHtmlEntities(this.secondaryMainAddressresponse.data?.addressLine2 || ''),
                addressLine3: this.decodeHtmlEntities(this.secondaryMainAddressresponse.data?.addressLine3 || ''),
                addressLine4: this.decodeHtmlEntities(this.secondaryMainAddressresponse.data?.addressLine4 || ''),
                addressLine5: this.secondaryMainAddressresponse.data?.addressLine5 || '',
                addressLine6: this.secondaryMainAddressresponse.data?.addressLine6 || '',
                addressLine7: this.secondaryMainAddressresponse.data?.addressLine7 || '',
                addressLine8: this.secondaryMainAddressresponse.data?.addressLine8 || '',
                addressLine9: this.secondaryMainAddressresponse.data?.addressLine9 || '',
                addressLine10: this.secondaryMainAddressresponse.data?.addressLine10 || '',
                addressText: this.secondaryResidentialAddress || '',
                city: this.secondaryMainAddressresponse.data.city,
                stateOrprovince: this.secondaryMainAddressresponse.data?.region || '',
                stateOrprovinceName: this.secondaryMainAddressresponse.data?.region || '',
                country: this.secondaryMainAddressresponse.data.countryCode,
                isDefault: (this.isDefaultSecondary === true),
              };
            }
            if (this.secondaryReviewCorresponding === true) {
              this.correspondingAddress = {
                postCode: this.primaryAddress.postCode.split(' ').join('').toLowerCase(),
                addressID: this.primaryAddress?.addressID || '',
                buildingNumber: '',
                addressLine1: this.primaryAddress?.addressLine1 || '',
                addressLine2: this.primaryAddress?.addressLine2 || '',
                addressLine3: this.primaryAddress?.addressLine3 || '',
                addressLine4: this.primaryAddress?.addressLine4 || '',
                addressLine5: this.primaryAddress?.addressLine5 || '',
                addressLine6: this.primaryAddress?.addressLine6 || '',
                addressLine7: this.primaryAddress?.addressLine7 || '',
                addressLine8: this.primaryAddress?.addressLine8 || '',
                addressLine9: this.primaryAddress?.addressLine9 || '',
                addressLine10: this.primaryAddress?.addressLine10 || '',
                addressText: this.primaryAddress?.addressText || '',
                city: this.primaryAddress?.city,
                stateOrprovince: this.primaryAddress?.stateOrprovince || '',
                stateOrprovinceName: this.primaryAddress?.stateOrprovince || '',
                country: this.primaryAddress?.country,
                isDefault: (this.isDefaultSecondary === false),
              };
              this.secondaryCorrespondenceAddress = '';
              this.secondaryCorrAddressresponse = '';
            } else if (this.secondaryReviewCorresponding === false) {
              if (contactReviewData?.correspondenceAddress?.addressID !== '' && this.secondaryCorrAddressresponse === '') {
                this.correspondingAddress = {
                  postCode: contactReviewData?.correspondenceAddress?.postCode.split(' ').join('').toLowerCase(),
                  addressID: contactReviewData?.correspondenceAddress?.addressID,
                  buildingNumber: null,
                  addressLine1: contactReviewData?.correspondenceAddress?.addressLine1 || '',
                  addressLine2: contactReviewData?.correspondenceAddress?.addressLine2 || '',
                  addressLine3: contactReviewData?.correspondenceAddress?.addressLine3 || '',
                  addressLine4: contactReviewData?.correspondenceAddress?.addressLine4 || '',
                  addressLine5: contactReviewData?.correspondenceAddress?.addressLine5 || '',
                  addressLine6: contactReviewData?.correspondenceAddress?.addressLine6 || '',
                  addressLine7: contactReviewData?.correspondenceAddress?.addressLine7 || '',
                  addressLine8: contactReviewData?.correspondenceAddress?.addressLine8 || '',
                  addressLine9: contactReviewData?.correspondenceAddress?.addressLine9 || '',
                  addressLine10: contactReviewData?.correspondenceAddress?.addressLine10 || '',
                  addressText: contactReviewData?.correspondenceAddress?.addressText || '',
                  city: contactReviewData?.correspondenceAddress?.city,
                  stateOrprovince: contactReviewData?.correspondenceAddress?.stateOrprovince || '',
                  stateOrprovinceName: contactReviewData?.correspondenceAddress?.stateOrprovince || '',
                  country: contactReviewData?.correspondenceAddress?.country,
                  isDefault: (this.isDefaultSecondary === false),
                };
              } else {
                this.correspondingAddress = {
                  postCode: this.secondaryCorrAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                  addressID: this.secondaryCorrAddressresponse.data?.addressId,
                  buildingNumber: null,
                  addressLine1: this.decodeHtmlEntities(this.secondaryCorrAddressresponse.data?.addressLine1 || ''),
                  addressLine2: this.decodeHtmlEntities(this.secondaryCorrAddressresponse.data?.addressLine2 || ''),
                  addressLine3: this.decodeHtmlEntities(this.secondaryCorrAddressresponse.data?.addressLine3 || ''),
                  addressLine4: this.decodeHtmlEntities(this.secondaryCorrAddressresponse.data?.addressLine4 || ''),
                  addressLine5: this.secondaryCorrAddressresponse.data?.addressLine5 || '',
                  addressLine6: this.secondaryCorrAddressresponse.data?.addressLine6 || '',
                  addressLine7: this.secondaryCorrAddressresponse.data?.addressLine7 || '',
                  addressLine8: this.secondaryCorrAddressresponse.data?.addressLine8 || '',
                  addressLine9: this.secondaryCorrAddressresponse.data?.addressLine9 || '',
                  addressLine10: this.secondaryCorrAddressresponse.data?.addressLine10 || '',
                  addressText: this.secondaryCorrespondenceAddress || '',
                  city: this.secondaryCorrAddressresponse.data?.city,
                  stateOrprovince: this.secondaryCorrAddressresponse.data?.region || '',
                  stateOrprovinceName: this.secondaryCorrAddressresponse.data?.region || '',
                  country: this.secondaryCorrAddressresponse.data.countryCode,
                  isDefault: (this.isDefaultSecondary === false),
                };
              }
            }
            if (this.secondarySelected === false) {
              if (contactReviewData?.previousResidentialAddress?.addressID !== '' && this.secondaryPrevAddressresponse === '') {
                this.previousResidentialAddress = {
                  postCode: contactReviewData?.previousResidentialAddress?.postCode.split(' ').join('').toLowerCase(),
                  addressID: contactReviewData?.previousResidentialAddress?.addressID || '',
                  buildingNumber: null,
                  addressLine1: contactReviewData?.previousResidentialAddress?.addressLine1 || '',
                  addressLine2: contactReviewData?.previousResidentialAddress?.addressLine2 || '',
                  addressLine3: contactReviewData?.previousResidentialAddress?.addressLine3 || '',
                  addressLine4: contactReviewData?.previousResidentialAddress?.addressLine4 || '',
                  addressLine5: contactReviewData?.previousResidentialAddress?.addressLine5 || '',
                  addressLine6: contactReviewData?.previousResidentialAddress?.addressLine6 || '',
                  addressLine7: contactReviewData?.previousResidentialAddress?.addressLine7 || '',
                  addressLine8: contactReviewData?.previousResidentialAddress?.addressLine8 || '',
                  addressLine9: contactReviewData?.previousResidentialAddress?.addressLine9 || '',
                  addressLine10: contactReviewData?.previousResidentialAddress?.addressLine10 || '',
                  addressText: contactReviewData?.previousResidentialAddress?.addressText || '',
                  city: contactReviewData?.previousResidentialAddress?.city,
                  stateOrprovince: contactReviewData?.previousResidentialAddress?.stateOrprovince || '',
                  stateOrprovinceName: contactReviewData?.previousResidentialAddress?.stateOrprovince || '',
                  country: contactReviewData?.previousResidentialAddress?.country,
                  fromDate: contactReviewData?.previousResidentialAddress?.fromDate,
                  toDate: contactReviewData?.previousResidentialAddress?.toDate,
                };
              } else {
                this.previousResidentialAddress = {
                  postCode: this.secondaryPrevAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                  addressID: this.secondaryPrevAddressresponse.data?.addressId,
                  buildingNumber: null,
                  addressLine1: this.secondaryPrevAddressresponse.data?.addressLine1 || '',
                  addressLine2: this.secondaryPrevAddressresponse.data?.addressLine2 || '',
                  addressLine3: this.secondaryPrevAddressresponse.data?.addressLine3 || '',
                  addressLine4: this.secondaryPrevAddressresponse.data?.addressLine4 || '',
                  addressLine5: this.secondaryPrevAddressresponse.data?.addressLine5 || '',
                  addressLine6: this.secondaryPrevAddressresponse.data?.addressLine6 || '',
                  addressLine7: this.secondaryPrevAddressresponse.data?.addressLine7 || '',
                  addressLine8: this.secondaryPrevAddressresponse.data?.addressLine8 || '',
                  addressLine9: this.secondaryPrevAddressresponse.data?.addressLine9 || '',
                  addressLine10: this.secondaryPrevAddressresponse.data?.addressLine10 || '',
                  addressText: this.secondaryPreviousResidentialAddress || '',
                  city: this.secondaryPrevAddressresponse.data?.city,
                  stateOrprovince: this.secondaryPrevAddressresponse.data?.region || '',
                  stateOrprovinceName: this.secondaryPrevAddressresponse.data?.region || '',
                  country: this.secondaryPrevAddressresponse.data.countryCode,
                  fromDate: this.fromDate,
                  toDate: this.toDate,
                };
              }
            } else if (this.selected === true) {
              this.previousResidentialAddress = '';
              this.prevAddressresponse = '';
              this.fromDate = '';
              this.toDate = '';
            }
          } else if (this.isAddressLookupEnabled === 'false' || this.secondaryAddressAddedManually) {
            this.primaryAddress = {
              postCode: this.secondaryFormData.primaryAddress.postCode,
              addressID: '',
              buildingNumber: '',
              addressLine1: this.secondaryFormData.primaryAddress.addressLine1,
              addressLine2: this.secondaryFormData.primaryAddress.addressLine2 || '',
              addressLine3: this.addPrimaryAddressLine3 ? this.secondaryFormData.primaryAddress.addressLine3 : '',
              addressLine4: this.addPrimaryAddressLine4 ? this.secondaryFormData.primaryAddress.addressLine4 : '',
              city: this.secondaryFormData.primaryAddress.city,
              stateOrprovince: this.secondaryFormData.primaryAddress.stateOrprovince,
              country: this.secondaryFormData.primaryAddress.country,
              stateOrprovinceName: this.secondaryFormData?.primaryStateDescription ?? contactReviewData?.primaryAddress?.stateOrprovinceName,
              countryName: this.isValueValid(this.secondaryFormData?.primaryCountryDescription) ? this.secondaryFormData?.primaryCountryDescription : contactReviewData?.primaryAddress?.countryName,
              isDefault: (this.isDefaultManualSecondary === true),
            };
            if (this.secondaryManualInputCorresponding === true) {
              this.correspondingAddress = {
                postCode: this.secondaryFormData.primaryAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.secondaryFormData.primaryAddress.addressLine1,
                addressLine2: this.secondaryFormData.primaryAddress.addressLine2 || '',
                addressLine3: this.addPrimaryAddressLine3 ? this.secondaryFormData.primaryAddress.addressLine3 : '',
                addressLine4: this.addPrimaryAddressLine3 && this.addPrimaryAddressLine4 ? this.secondaryFormData.primaryAddress.addressLine4 : '',
                city: this.secondaryFormData.primaryAddress.city,
                stateOrprovince: this.secondaryFormData.primaryAddress.stateOrprovince,
                stateOrprovinceName: this.secondaryFormData?.primaryStateDescription ?? contactReviewData?.primaryAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.secondaryFormData?.primaryCountryDescription) ? this.secondaryFormData?.primaryCountryDescription : contactReviewData?.primaryAddress?.countryName,
                country: this.secondaryFormData.primaryAddress.country,
                isDefault: (this.isDefaultManualSecondary === false),
              };
            } else if (this.secondaryManualInputCorresponding === false) {
              this.correspondingAddress = {
                postCode: this.secondaryFormData.correspondenceAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.secondaryFormData.correspondenceAddress.addressLine1,
                addressLine2: this.secondaryFormData.correspondenceAddress.addressLine2 || '',
                addressLine3: this.addcorrAddressLine3 ? this.secondaryFormData.correspondenceAddress.addressLine3 : '',
                addressLine4: this.addcorrAddressLine3 && this.addcorrAddressLine4 ? this.secondaryFormData.correspondenceAddress.addressLine4 : '',
                city: this.secondaryFormData.correspondenceAddress.city,
                stateOrprovince: this.secondaryFormData.correspondenceAddress.stateOrprovince,
                country: this.secondaryFormData.correspondenceAddress.country,
                stateOrprovinceName: this.secondaryFormData?.correspondenceStateDescription ?? contactReviewData?.correspondenceAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.secondaryFormData?.correspondenceCountryDescription) ? this.secondaryFormData?.correspondenceCountryDescription : contactReviewData?.correspondenceAddress?.countryName,
                isDefault: (this.isDefaultManualSecondary === false),
              };
            }
            if (this.secondaryPrevManualAddress === false) {
              this.previousResidentialAddress = {
                postCode: this.secondaryFormData.previousResidentialAddress.postCode,
                addressID: '',
                buildingNumber: '',
                addressLine1: this.secondaryFormData.previousResidentialAddress.addressLine1,
                addressLine2: this.secondaryFormData.previousResidentialAddress.addressLine2,
                addressLine3: this.addprevAddressLine3 ? this.secondaryFormData.previousResidentialAddress.addressLine3 : '',
                addressLine4: this.addprevAddressLine3 && this.addprevAddressLine4 ? this.secondaryFormData.previousResidentialAddress.addressLine4 : '',
                city: this.secondaryFormData.previousResidentialAddress.city,
                stateOrprovince: this.secondaryFormData.previousResidentialAddress.stateOrprovince,
                country: this.secondaryFormData.previousResidentialAddress.country,
                stateOrprovinceName: this.secondaryFormData?.previousStateDescription ?? contactReviewData?.previousResidentialAddress?.stateOrprovinceName,
                countryName: this.isValueValid(this.secondaryFormData?.previousCountryDescription) ? this.secondaryFormData?.previousCountryDescription : contactReviewData?.previousResidentialAddress?.countryName,
                fromDate: this.secondaryFormData.previousResidentialAddress.fromDate || this.fromDate,
                toDate: this.secondaryFormData.previousResidentialAddress.toDate || this.toDate,
              };
            }
          }

          if (this.addressSameAsPrimary) {
            if ((this.isAddressLookupEnabled === 'true' && !this.secondaryAddressAddedManually && this.secondarySelected === false) || (this.secondaryAddressAddedManually && this.secondaryPrevManualAddress === false)) {
              contactInformation = JSON.stringify({ primaryAddress: primaryContactData?.primaryAddress,
                correspondenceAddress: primaryContactData?.correspondenceAddress,
                previousResidentialAddress: primaryContactData?.previousResidentialAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: primaryContactData?.primaryAddress,
                  correspondenceAddress: primaryContactData?.correspondenceAddress,
                  previousResidentialAddress: primaryContactData?.previousResidentialAddress,
                }] });
            } else if (this.correspondingAddress !== '' && this.correspondingAddress !== null) {
              contactInformation = JSON.stringify({
                primaryAddress: primaryContactData?.primaryAddress,
                correspondenceAddress: primaryContactData?.correspondenceAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: primaryContactData?.primaryAddress,
                  correspondenceAddress: primaryContactData?.correspondenceAddress,
                }],
              });
            } else {
              contactInformation = JSON.stringify({ primaryAddress: primaryContactData?.primaryAddress, secondaryApplicantsContactInformation: primaryContactData?.primaryAddress });
            }
          } else {
            if (((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && !this.secondaryAddressAddedManually && this.secondarySelected === false) || (this.secondaryAddressAddedManually && this.secondaryPrevManualAddress === false)) {
              contactInformation = JSON.stringify({ primaryAddress: primaryContactData?.primaryAddress,
                correspondenceAddress: primaryContactData?.correspondenceAddress,
                previousResidentialAddress: primaryContactData?.previousResidentialAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: this.primaryAddress,
                  correspondenceAddress: this.correspondingAddress,
                  previousResidentialAddress: this.previousResidentialAddress,
                }] });
            } else if (this.correspondingAddress !== '' && this.correspondingAddress !== null) {
              contactInformation = JSON.stringify({
                primaryAddress: primaryContactData?.primaryAddress,
                correspondenceAddress: primaryContactData?.correspondenceAddress,
                previousResidentialAddress: primaryContactData?.previousResidentialAddress,
                secondaryApplicantsContactInformation: [{
                  primaryAddress: this.primaryAddress,
                  correspondenceAddress: this.correspondingAddress,
                }],
              });
            } else {
              contactInformation = JSON.stringify({ primaryAddress: primaryContactData?.primaryAddress, secondaryApplicantsContactInformation: [{ primaryAddress: this.primaryAddress }] });
            }
          }
        } else if (editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation') {
          const isPersonalInformation = editedSectionData === 'personalInformation';

          personalInformation = JSON.stringify({
            titleCode: primaryPersonalData?.titleCode,
            titleDescription: primaryPersonalData?.titleDescription,
            firstName: primaryPersonalData?.firstName,
            middleName: primaryPersonalData?.middleName,
            lastName: primaryPersonalData?.lastName,
            gender: primaryPersonalData?.gender,
            dateOfBirth: primaryPersonalData?.dateOfBirth,
            nationalIdTypeId: primaryPersonalData?.nationalIdTypeId,
            nationalIdTypeCode: primaryPersonalData?.nationalIdTypeCode,
            nationalIdNumber: primaryPersonalData?.nationalIdNumber,
            residentCountryId: primaryPersonalData?.residentCountryId,
            residentCountryCode: primaryPersonalData?.residentCountryCode,
            birthCountryCode: primaryPersonalData?.birthCountryCode,
            birthCountryName: primaryPersonalData?.birthCountryDescription,
            areYouAUKResident: 'true',
            primaryNationality: primaryPersonalData?.primaryNationality,
            primaryNationalityDescription: primaryPersonalData?.primaryNationalityDescription,
            secondaryNationality: primaryPersonalData?.secondaryNationality || '',
            preferredLanguageName: '',
            preferredLanguageCode: this.localeSelected,
            sourceCountryOfFunds: primaryPersonalData?.sourceCountryOfFunds,
            job: primaryPersonalData?.job,
            jobDescription: primaryPersonalData?.jobDescription,
            udfBusinessType: primaryPersonalData?.udfBusinessType,
            udfBusinessTypeDescription: primaryPersonalData?.udfBusinessTypeDescription,
            expectedTurnover: primaryPersonalData?.expectedTurnover,
            sourceCountryOfFundsDescription: primaryPersonalData?.sourceCountryOfFundsDescription,
            secondaryApplicantsPersonalInformation: [{
              titleCode: isPersonalInformation ? this.secondaryFormData.titleCode : personalReviewData?.titleCode,
              titleDescription: isPersonalInformation ? this.secondaryFormData.titleDescription : personalReviewData?.titleDescription,
              firstName: isPersonalInformation ? this.secondaryFormData.firstName : personalReviewData?.firstName,
              middleName: isPersonalInformation ? this.secondaryFormData.middleName : personalReviewData?.middleName,
              lastName: isPersonalInformation ? this.secondaryFormData.lastName : personalReviewData?.lastName,
              gender: isPersonalInformation ? this.secondaryFormData.gender : personalReviewData?.gender,
              dateOfBirth: isPersonalInformation ? this.secondaryFormData.year + '-' + this.secondaryFormData.month + '-' + this.secondaryFormData.date : personalReviewData?.dateOfBirth,
              nationalIdTypeId: isPersonalInformation ? this.secondaryFormData.nationalIdTypeId : personalReviewData?.nationalIdTypeId,
              nationalIdTypeCode: isPersonalInformation ? this.secondaryFormData?.nationalIdTypeCode : personalReviewData?.nationalIdTypeCode,
              nationalIdNumber: isPersonalInformation ? this.secondaryFormData.nationalIdNumber : personalReviewData?.nationalIdNumber,
              residentCountryId: 'UK',
              residentCountryCode: 'UK',
              birthCountryCode: isPersonalInformation ? this.secondaryFormData.birthCountryCode : personalReviewData?.birthCountryCode,
              birthCountryName: isPersonalInformation ? this.secondaryFormData.birthCountryDescription : personalReviewData?.birthCountryDescription,
              areYouAUKResident: 'true',
              primaryNationality: isPersonalInformation ? this.secondaryFormData.primaryNationality : personalReviewData?.primaryNationality,
              primaryNationalityDescription: isPersonalInformation ? this.secondaryFormData.primaryNationalityDescription : personalReviewData?.primaryNationalityDescription,
              secondaryNationality: isPersonalInformation ? this.secondaryFormData.secondaryNationality : personalReviewData?.secondaryNationality,
              preferredLanguageName: '',
              preferredLanguageCode: this.localeSelected,
              sourceCountryOfFunds: isPersonalInformation ? personalReviewData?.sourceCountryOfFunds : this.secondaryFormData.sourceCountryOfFunds,
              job: isPersonalInformation ? personalReviewData?.job : this.secondaryFormData.job,
              jobDescription: isPersonalInformation ? personalReviewData?.jobDescription : this.secondaryFormData.jobDescription !== undefined ? this.secondaryFormData.jobDescription : personalReviewData?.jobDescription,
              udfBusinessType: isPersonalInformation ? personalReviewData?.udfBusinessType : this.secondaryFormData.udfBusinessType,
              udfBusinessTypeDescription: isPersonalInformation ? personalReviewData?.udfBusinessTypeDescription : this.secondaryFormData.udfBusinessTypeDescription !== undefined ? this.secondaryFormData.udfBusinessTypeDescription : personalReviewData?.udfBusinessTypeDescription,
              expectedTurnover: isPersonalInformation ? personalReviewData?.expectedTurnover : this.secondaryFormData.expectedTurnover,
              sourceCountryOfFundsDescription: isPersonalInformation ? personalReviewData?.sourceCountryOfFundsDescription : this.secondaryFormData.sourceCountryOfFundsDescription !== undefined ? this.secondaryFormData.sourceCountryOfFundsDescription : personalReviewData?.sourceCountryOfFundsDescription,
              secondaryApplicantsEmailId: personalReviewData?.secondaryApplicantsEmailId,
              secondaryApplicantsMobileCountryCode: personalReviewData?.secondaryApplicantsMobileCountryCode,
              secondaryApplicantsMobilePhoneNumber: personalReviewData?.secondaryApplicantsMobilePhoneNumber,
            }],
          });
        } else if (editedSectionData === 'taxInformation') {
          taxInformation = JSON.stringify({
            taxPayerFlag: primaryTaxData?.taxPayerFlag,
            countryOfTaxResidentCode: primaryTaxData?.countryOfTaxResidentCode || 'GBR',
            countryOfTaxResidentName: primaryTaxData?.countryOfTaxResidenceDescription || 'United Kingdom',
            taxIdentificationNumber: primaryTaxData?.taxIdentificationNumber,
            taxExemptionReason: primaryTaxData?.taxExemptionReason,
            taxExemptionReasonName: primaryTaxData?.taxExemptionDescription,
            taxResidentInOtherCountry: primaryTaxData?.taxResidentInOtherCountry,
            foreignCountryOfTaxResidence: primaryTaxData?.foreignCountryOfTaxResidence,
            foreignCountryOfTaxResidenceName: primaryTaxData?.foreignCountryOfTaxResidenceDescription,
            tinNumberInOtherCountry: primaryTaxData?.tinNumberInOtherCountry,
            areYouUSResident: primaryTaxData?.areYouUSResident,
            secondaryApplicantsTaxInformation: [{
              taxPayerFlag: this.secondaryTaxValue,
              countryOfTaxResidentCode: this.secondaryFormData.countryOfTaxResidentCode || 'GBR',
              countryOfTaxResidentName: this.secondaryFormData.countryOfTaxResidenceDescription || 'United Kingdom',
              taxIdentificationNumber: this.secondaryTaxValue ? this.secondaryFormData.taxIdentificationNumber : '',
              taxExemptionReason: this.secondaryTaxValue === false ? this.secondaryFormData.taxExemptionReason : '',
              taxExemptionReasonName: this.secondaryTaxValue === false ? this.secondaryFormData.taxExemptionDescription : '',
              taxResidentInOtherCountry: this.secondaryTaxValue ? this.taxResidentInOtherCountry : '',
              foreignCountryOfTaxResidence: this.secondaryTaxResidentInOtherCountry ? this.secondaryFormData.foreignCountryOfTaxResidence : '',
              foreignCountryOfTaxResidenceName: this.secondaryFormData.foreignCountryOfTaxResidenceDescription,
              tinNumberInOtherCountry: this.secondaryTaxResidentInOtherCountry ? this.secondaryFormData.tinNumberInOtherCountry : '',
              areYouUSResident: this.secondaryTaxResidentInOtherCountry ? this.areYouUSResident : false,
            }],
          });
        }
        const employmentDetails = {
          employmentStatus: this.secondaryFormData.employmentStatus,
          nameOfTheEmployer: this.secondaryFormData.nameOfTheEmployer,
          employmentType: this.secondaryFormData.employmentType,
          businessType: this.secondaryFormData.businessType,
          jobTitle: this.secondaryFormData.jobTitle,
          paymentMethod: this.secondaryFormData.paymentMethod,
          paymentFrequency: this.secondaryFormData.paymentFrequency,
          employmentStatusDescription: this.secondaryFormData?.employmentStatusDescription ? this.secondaryFormData?.employmentStatusDescription : '',
          employmentTypeDescription: this.secondaryFormData?.employmentTypeDescription ? this.secondaryFormData?.employmentTypeDescription : '',
          businessTypeDescription: this.secondaryFormData?.businessTypeDescription ? this.secondaryFormData?.businessTypeDescription : '',
          jobTitleDescription: this.secondaryFormData?.jobTitleDescription ? this.secondaryFormData?.jobTitleDescription : '',
          paymentMethodDescription: this.secondaryFormData?.paymentMethodDescription ? this.secondaryFormData?.paymentMethodDescription : '',
          paymentFrequencyDescription: this.secondaryFormData?.paymentFrequencyDescription ? this.secondaryFormData?.paymentFrequencyDescription : '',
        };

        const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
        const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

        this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
        productInformation = JSON.stringify({
          productTypeCode: this.apiProductType,
          productId: productMapping.data.productCode,
          accountOwnership: this.accountOwnership,
          modeOfOperation: this.modeOfOperation,
          tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
          tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
          interestRate: '',
          postingRestriction: '',
          currencyCode: productMapping.data.currencyCode,
          maturityInstruction: '',
          module: productMapping.data.module,
          purposeOfAccount: primaryProductData?.purposeOfAccount,
          purposeOfAccountDescription: primaryProductData?.purposeOfAccountDescription,
          purposeOfAccountOthers: primaryProductData?.purposeOfAccountOthers,
          expectedUsage: primaryProductData?.expectedUsage,
          expectedUsageDescription: primaryProductData?.expectedUsageDescription,
          productEndDate: productMapping?.data?.productEndDate,
          isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
          productSubType: this.getProductType || '',
        });
        const data = {
          accountInformation: reviewMappingData?.accountInformation,
          activeFlag: reviewMappingData.activeFlag,
          activeFrom: reviewMappingData.activeFrom,
          activeTill: reviewMappingData.activeTill,
          applicationId: reviewMappingData.applicationId,
          applicationNumber: reviewMappingData.applicationNumber,
          applicationStatus: reviewMappingData.applicationStatus,
          createdBy: reviewMappingData.createdBy,
          createdDate: reviewMappingData.createdDate,
          customerId: reviewMappingData.customerId,
          deletedFlag: reviewMappingData.deletedFlag,
          documentInformation: reviewMappingData.documentInformation,
          emailId: reviewMappingData.emailId,
          entityId: reviewMappingData.entityId,
          lastModifiedBy: reviewMappingData.lastModifiedBy,
          lastModifiedDate: reviewMappingData.lastModifiedDate,
          mobileCountryCode: reviewMappingData.mobileCountryCode,
          mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
          personalInformation: editedSectionData === 'personalInformation' ? personalInformation : reviewMappingData?.personalInformation,
          productInformation: productInformation,
          contactInformation: editedSectionData === 'addressInformation' ? contactInformation : reviewMappingData?.contactInformation,
          taxInformation: editedSectionData === 'taxInformation' ? taxInformation : reviewMappingData?.taxInformation,
          otherInformation: {
            employmentDetails: primaryOtherInfo?.employmentDetails,
            mobileNumberVerified: true,
            addressLookupEnabled: primaryOtherInfo && primaryOtherInfo?.addressLookupEnabled,
            lisaTransferInWithAgeValidation: this.getProductType === 'lifetimeISA' ? localStorage.getItem('isLisaTransferInWithAgeCheck') : otherInfo?.lisaTransferInWithAgeValidation,
            secondaryApplicantsOtherInformation: [{
              employmentDetails: editedSectionData === 'employmentInformation' ? employmentDetails : otherInfo?.employmentDetails,
              relationshipType: this.secondaryFormData.relationshipType !== undefined ? this.secondaryFormData?.relationshipType : otherInfo?.relationshipType,
              relationshipTypeDescription: this.secondaryFormData?.relationshipTypeDescription !== undefined ? this.secondaryFormData?.relationshipTypeDescription : otherInfo?.relationshipType,
            }] },
          readOnlyFlag: reviewMappingData.readOnlyFlag,
          statusInformation: reviewMappingData.statusInformation,
          systemFlag: reviewMappingData.systemFlag,
          tenantId: reviewMappingData.tenantId,
          version: reviewMappingData.version,
          b2bSessionId: reviewMappingData.b2bSessionId,
        };
        const additionalInfoData = await CommonService.postData(urlObj.save, data);

        if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
          this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
        } else {
          store.dispatch('userStore/setUserData', { additionalInfoData });
          this.showUnsavedSnackbar(readonlyKey, true, 'secondary');
          window.scrollTo(0, 0);
          this.reviewScreenData();
        }
      }
    },
    async saveAccountOwnerShipDetails() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const productInformation = JSON.parse(reviewMappingData.productInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;

      const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
      const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

      this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
      const data = {
        accountInformation: reviewMappingData.accountInformation,
        activeFlag: reviewMappingData.activeFlag,
        activeFrom: reviewMappingData.activeFrom,
        activeTill: reviewMappingData.activeTill,
        applicationId: reviewMappingData.applicationId,
        applicationNumber: reviewMappingData.applicationNumber,
        applicationStatus: reviewMappingData.applicationStatus,
        createdBy: reviewMappingData.createdBy,
        createdDate: reviewMappingData.createdDate,
        customerId: reviewMappingData.customerId,
        deletedFlag: reviewMappingData.deletedFlag,
        documentInformation: reviewMappingData.documentInformation,
        emailId: reviewMappingData.emailId,
        entityId: reviewMappingData.entityId,
        lastModifiedBy: reviewMappingData.lastModifiedBy,
        lastModifiedDate: reviewMappingData.lastModifiedDate,
        mobileCountryCode: reviewMappingData.mobileCountryCode,
        mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
        personalInformation: reviewMappingData?.personalInformation,
        productInformation: JSON.stringify({
          productTypeCode: this.apiProductType,
          productId: productMapping.data.productCode,
          accountOwnership: this.accountOwnership,
          modeOfOperation: this.formData.modeOfOperation,
          tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
          tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
          interestRate: '',
          postingRestriction: '',
          currencyCode: productMapping.data.currencyCode,
          maturityInstruction: '',
          module: productMapping.data.module,
          purposeOfAccount: productInformation.purposeOfAccount,
          purposeOfAccountOthers: productInformation.purposeOfAccountOthers,
          expectedUsage: productInformation.expectedUsage,
          purposeOfAccountDescription: productInformation.purposeOfAccountDescription,
          expectedUsageDescription: productInformation.expectedUsageDescription,
          productEndDate: productMapping?.data?.productEndDate,
          isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
          productSubType: this.getProductType || '',
        }),
        contactInformation: reviewMappingData?.contactInformation,
        taxInformation: reviewMappingData?.taxInformation,
        otherInformation: JSON.parse(reviewMappingData?.otherInformation),
        b2bSessionId: reviewMappingData?.b2bSessionId,
      };
      const additionalInfoData = await CommonService.postData(urlObj.save, data);

      if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
        this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
      } else {
        store.dispatch('userStore/setUserData', { additionalInfoData });
        localStorage.setItem('additionalInfoData', JSON.stringify(additionalInfoData));
        await this.reviewScreenData();
        return additionalInfoData;
      }
    },
    async finalDelete() {
      this.reviewExitButton = false;

      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const entityId = reviewMappingData.entityId;
      const deleteDatas = await CommonService.deleteDcoData(`${urlObj.deleteData}/${entityId}`);

      if (deleteDatas.status === 204 || deleteDatas.status === 200) {
        this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
        const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;

        setTimeout(function() {
          window.location.href = appSettings.dco.bankProductPage;
        }, redirectTimeout);
      }
    },
    async lastSave() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const data = {
        accountInformation: reviewMappingData.accountInformation,
        activeFlag: reviewMappingData.activeFlag,
        activeFrom: reviewMappingData.activeFrom,
        activeTill: reviewMappingData.activeTill,
        applicationId: reviewMappingData.applicationId,
        applicationNumber: reviewMappingData.applicationNumber,
        applicationStatus: reviewMappingData.applicationStatus,
        createdBy: reviewMappingData.createdBy,
        createdDate: reviewMappingData.createdDate,
        customerId: reviewMappingData.customerId,
        deletedFlag: reviewMappingData.deletedFlag,
        documentInformation: reviewMappingData.documentInformation,
        emailId: reviewMappingData.emailId,
        entityId: reviewMappingData.entityId,
        lastModifiedBy: reviewMappingData.lastModifiedBy,
        lastModifiedDate: reviewMappingData.lastModifiedDate,
        mobileCountryCode: reviewMappingData.mobileCountryCode,
        mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
        otherInformation: reviewMappingData.otherInformation,
        personalInformation: reviewMappingData.personalInformation,
        productInformation: reviewMappingData.productInformation,
        contactInformation: reviewMappingData.contactInformation,
        taxInformation: reviewMappingData.taxInformation,
        readOnlyFlag: reviewMappingData.readOnlyFlag,
        systemFlag: reviewMappingData.systemFlag,
        tenantId: reviewMappingData.tenantId,
        version: reviewMappingData.version,
        statusInformation: reviewMappingData.statusInformation,
        b2bSessionId: reviewMappingData.b2bSessionId,
      };
      const additionalInfoData = await CommonService.postData(urlObj.editSave, data);

      if ([400, 401, 403, 404, 413, 429, 500, 503].includes(additionalInfoData?.data?.status)) {
        this.displaySnackBar({ title: additionalInfoData.data.title, content: additionalInfoData.data.causes[0].message, type: 'error' });
      } else {
        store.dispatch('userStore/setUserData', { additionalInfoData });
        if (additionalInfoData !== null) {
          this.reviewExitButton = false;
          this.displaySnackBar({
            title: `${this.$t('messages.save.success')}`,
            content: this.$t('messages.save.saveSuccess'),
            type: 'success',
          });
          const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;

          setTimeout(function() {
            window.location.href = appSettings.dco.bankProductPage;
          }, redirectTimeout);
        }
      }
    },
    async finalSubmit() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      let productData = JSON.parse(reviewMappingData.productInformation);
      let secondaryContactInformation = [];
      let adressLookUpEnabledCountryCode = '';

      window.scrollTo(0, 0);
      this.identityVerificationQuery = false;

      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const address = JSON.parse(reviewMappingData.contactInformation);
      const primaryAddressID = address?.primaryAddress?.addressID;
      const primaryAddress = primaryAddressID?.replaceAll('|', '%');

      this.applicationNumber = reviewMappingData.applicationNumber;
      const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
      const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

      this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
      productData = JSON.stringify({
        productTypeCode: this.apiProductType,
        productId: productMapping.data.productCode,
        accountOwnership: productMapping.data.applicableAccountOperationType === 'SINGLE' ? 'SOLE' : productMapping.data?.module && this.$appSettings?.dcoConfigurations.module.includes(productMapping.data?.module) ? this.accountOwnership : 'SOLE',
        modeOfOperation: productMapping.data.applicableAccountOperationType === 'SINGLE' ? 'SOLE' : this.$appSettings?.dcoConfigurations.module.includes(productMapping.data?.module) ? this.modeOfOperation.toUpperCase() : 'SOLE',
        tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
        tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
        interestRate: '',
        postingRestriction: '',
        currencyCode: productMapping.data.currencyCode,
        maturityInstruction: '',
        module: productMapping.data?.module,
        purposeOfAccount: productData?.purposeOfAccount,
        purposeOfAccountOthers: productData?.purposeOfAccountOthers,
        expectedUsage: productData?.expectedUsage,
        purposeOfAccountDescription: productData?.purposeOfAccountDescription,
        expectedUsageDescription: productData?.expectedUsageDescription,
        productEndDate: productMapping?.data?.productEndDate,
        isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
        productSubType: this.getProductType || '',
      });
      if (address && address.primaryAddress?.addressID !== '' && address.primaryAddress?.addressID !== null && address.primaryAddress?.stateOrprovince !== '' && address.primaryAddress?.stateOrprovince !== null) {
        const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${address.primaryAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
        const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === address.primaryAddress?.stateOrprovince);
        adressLookUpEnabledCountryCode = country ? country.stateOrProvince : '';
      }
      this.primaryAddress = {
        postCode: address.primaryAddress.postCode,
        addressID: primaryAddress,
        buildingNumber: address.primaryAddress.buildingNumber,
        addressLine1: address.primaryAddress.addressLine1,
        addressLine2: address.primaryAddress.addressLine2,
        addressLine3: address.primaryAddress.addressLine3,
        addressLine4: address.primaryAddress.addressLine4,
        addressLine5: address.primaryAddress.addressLine5,
        addressLine6: address.primaryAddress.addressLine6,
        addressLine7: address.primaryAddress.addressLine7,
        addressLine8: address.primaryAddress.addressLine8,
        addressLine9: address.primaryAddress.addressLine9,
        addressLine10: address.primaryAddress.addressLine10,
        city: address.primaryAddress.city,
        country: address.primaryAddress.country,
        countryCode: address.primaryAddress.countryCode,
        stateOrprovince: adressLookUpEnabledCountryCode || address.primaryAddress.stateOrprovince,
        isDefault: address.primaryAddress.isDefault,
      };
      if (address && address?.correspondenceAddress) {
        const correspondenceAddressID = address?.correspondenceAddress?.addressID;
        const correspondenceAddress = correspondenceAddressID?.replaceAll('|', '%');

        if (address && address.correspondenceAddress?.addressID !== '' && address.correspondenceAddress?.addressID !== null && address.correspondenceAddress?.stateOrprovince !== '' && address.correspondenceAddress?.stateOrprovince !== null) {
          const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${address.correspondenceAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
          const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === address.correspondenceAddress?.stateOrprovince);

          adressLookUpEnabledCountryCode = country ? country.stateOrProvince : '';
        }

        this.correspondingAddress = {
          postCode: address.correspondenceAddress.postCode,
          addressID: correspondenceAddress,
          buildingNumber: address.correspondenceAddress.buildingNumber,
          addressLine1: address.correspondenceAddress.addressLine1,
          addressLine2: address.correspondenceAddress.addressLine2,
          addressLine3: address.correspondenceAddress.addressLine3,
          addressLine4: address.correspondenceAddress.addressLine4,
          addressLine5: address.correspondenceAddress.addressLine5,
          addressLine6: address.correspondenceAddress.addressLine6,
          addressLine7: address.correspondenceAddress.addressLine7,
          addressLine8: address.correspondenceAddress.addressLine8,
          addressLine9: address.correspondenceAddress.addressLine9,
          addressLine10: address.correspondenceAddress.addressLine10,
          city: address.correspondenceAddress.city,
          country: address.correspondenceAddress.country,
          countryCode: address.correspondenceAddress.countryCode,
          stateOrprovince: adressLookUpEnabledCountryCode || address?.correspondenceAddress?.stateOrprovince,
          isDefault: address.correspondenceAddress.isDefault,
        };
      }
      if (address && address.previousResidentialAddress) {
        const previousResidentialAddressID = address && address.previousResidentialAddress && address?.previousResidentialAddress?.addressID;
        const previousResidentialAddress = address && address.previousResidentialAddress && previousResidentialAddressID?.replaceAll('|', '%');

        if (address && address.previousResidentialAddress?.addressID !== '' && address.previousResidentialAddress?.addressID !== null && address.previousResidentialAddress?.stateOrprovince !== '' && address.previousResidentialAddress?.stateOrprovince !== null) {
          const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${address.previousResidentialAddress?.country}`, { b2bSessionId: this.b2bSessionId }, false);
          const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === address.previousResidentialAddress?.stateOrprovince);

          adressLookUpEnabledCountryCode = country ? country.stateOrProvince : '';
        }

        this.previousResidentialAddress = {
          postCode: address.previousResidentialAddress.postCode,
          addressID: previousResidentialAddress,
          buildingNumber: address.previousResidentialAddress.buildingNumber,
          addressLine1: address.previousResidentialAddress.addressLine1,
          addressLine2: address.previousResidentialAddress.addressLine2,
          addressLine3: address.previousResidentialAddress.addressLine3,
          addressLine4: address.previousResidentialAddress.addressLine4,
          addressLine5: address.previousResidentialAddress.addressLine5,
          addressLine6: address.previousResidentialAddress.addressLine6,
          addressLine7: address.previousResidentialAddress.addressLine7,
          addressLine8: address.previousResidentialAddress.addressLine8,
          addressLine9: address.previousResidentialAddress.addressLine9,
          addressLine10: address.previousResidentialAddress.addressLine10,
          city: address.previousResidentialAddress.city,
          country: address.previousResidentialAddress.country,
          countryCode: address.previousResidentialAddress.countryCode,
          stateOrprovince: adressLookUpEnabledCountryCode || address?.previousResidentialAddress?.stateOrprovince,
          fromDate: address.previousResidentialAddress.fromDate,
          toDate: address.previousResidentialAddress.toDate,
        };
      }

      if (['savings', 'termDeposit'].includes(this.getProductType) && this.accountOwnership === 'JOINT') {
        const secondaryApplicantsAddressData = address?.secondaryApplicantsContactInformation[0];
        const primary = secondaryApplicantsAddressData?.primaryAddress;
        const correspondence = secondaryApplicantsAddressData?.correspondenceAddress;
        const previousResidential = secondaryApplicantsAddressData?.previousResidentialAddress;

        for (const key in primary) {
          if (key !== 'isDefault' && primary[key]?.includes('|')) {
            primary[key] = primary[key].replaceAll('|', '%');
          }
          if (key === 'stateOrprovince') {
            if (primary && primary?.addressID !== '' && primary?.addressID !== null && primary?.stateOrprovince !== '' && primary?.stateOrprovince !== null) {
              const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${primary?.country}`, { b2bSessionId: this.b2bSessionId }, false);
              const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === primary?.stateOrprovince);

              primary[key] = country ? country.stateOrProvince : primary?.stateOrprovince;
            }
          }
        }
        if (secondaryApplicantsAddressData && secondaryApplicantsAddressData?.correspondenceAddress) {
          for (const key in correspondence) {
            if (key !== 'isDefault' && correspondence[key]?.includes('|')) {
              correspondence[key] = correspondence[key].replaceAll('|', '%');
            }
            if (key === 'stateOrprovince') {
              if (correspondence && correspondence?.addressID !== '' && correspondence?.addressID !== null && correspondence?.stateOrprovince !== '' && correspondence?.stateOrprovince !== null) {
                const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${correspondence?.country}`, { b2bSessionId: this.b2bSessionId }, false);
                const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === correspondence?.stateOrprovince);

                correspondence[key] = country ? country.stateOrProvince : correspondence?.stateOrprovince;
              }
            }
          }
        }
        if (secondaryApplicantsAddressData && secondaryApplicantsAddressData.previousResidentialAddress) {
          for (const key in previousResidential) {
            if (key !== 'isDefault' && previousResidential[key]?.includes('|')) {
              previousResidential[key] = previousResidential[key].replaceAll('|', '%');
            }
            if (key === 'stateOrprovince') {
              if (previousResidential && previousResidential?.addressID !== '' && previousResidential?.addressID !== null && previousResidential?.stateOrprovince !== '' && previousResidential?.stateOrprovince !== null) {
                const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${previousResidential?.country}`, { b2bSessionId: this.b2bSessionId }, false);
                const country = primaryState?.data.find((item) => item.stateOrProvinceDescription === previousResidential?.stateOrprovince);

                previousResidential[key] = country ? country.stateOrProvince : previousResidential?.stateOrprovince;
              }
            }
          }
        }
        secondaryContactInformation = secondaryApplicantsAddressData?.previousResidentialAddress && secondaryApplicantsAddressData?.correspondenceAddress
          ? [{
            primaryAddress: primary,
            correspondenceAddress: correspondence,
            previousResidentialAddress: previousResidential,
          }] : secondaryApplicantsAddressData?.correspondenceAddress ? [{
            primaryAddress: primary,
            correspondenceAddress: correspondence,
          }] : [{
            primaryAddress: primary,
          }];
      }

      const data = {
        accountInformation: this.$appSettings?.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.$route?.params?.productType) ? reviewMappingData?.accountInformation : null,
        activeFlag: reviewMappingData.activeFlag,
        activeFrom: reviewMappingData.activeFrom,
        activeTill: reviewMappingData.activeTill,
        applicationId: reviewMappingData.applicationId,
        applicationNumber: reviewMappingData.applicationNumber,
        applicationStatus: reviewMappingData?.applicationStatus === 'IDENTITY_VERIFICATION_SUBMITTED' ? 'STARTED' : reviewMappingData.applicationStatus,
        createdBy: reviewMappingData.createdBy,
        createdDate: reviewMappingData.createdDate,
        customerId: reviewMappingData.customerId,
        deletedFlag: reviewMappingData.deletedFlag,
        documentInformation: reviewMappingData.documentInformation,
        emailId: reviewMappingData.emailId,
        entityId: reviewMappingData.entityId,
        lastModifiedBy: reviewMappingData.lastModifiedBy,
        lastModifiedDate: reviewMappingData.lastModifiedDate,
        mobileCountryCode: reviewMappingData.mobileCountryCode,
        mobilePhoneNumber: reviewMappingData.mobilePhoneNumber,
        otherInformation: reviewMappingData.otherInformation,
        personalInformation: reviewMappingData.personalInformation,
        productInformation: productData,
        contactInformation:
        address && address.previousResidentialAddress
          ? JSON.stringify({
            primaryAddress: this.primaryAddress,
            correspondenceAddress: this.correspondingAddress,
            previousResidentialAddress: this.previousResidentialAddress,
            secondaryApplicantsContactInformation: secondaryContactInformation,
          })
          : address && address.correspondenceAddress ? JSON.stringify({
            primaryAddress: this.primaryAddress,
            correspondenceAddress: this.correspondingAddress,
            secondaryApplicantsContactInformation: secondaryContactInformation,
          }) : JSON.stringify({
            primaryAddress: this.primaryAddress,
            secondaryApplicantsContactInformation: secondaryContactInformation,
          }),
        taxInformation: reviewMappingData.taxInformation,
        readOnlyFlag: reviewMappingData.readOnlyFlag,
        systemFlag: reviewMappingData.systemFlag,
        tenantId: reviewMappingData.tenantId,
        version: reviewMappingData.version,
        statusInformation: JSON.stringify({
          consentAcceptedFlag: this.consentAcceptedFlag,
          consents: this.partyConsents,
          accountConsents: this.accountConsents,
          activateEmailNotificationsFlag: this.activateEmailNotificationsFlag,
          activatePushNotificationsFlag: this.activatePushNotificationsFlag,
          activateSMSNotificationsFlag: this.activateMarketingCommunicationsFlag === true ? this.activateSMSNotificationsFlag : false,
          activatePostNotificationsFlag: this.activatePostNotificationsFlag,
          activateMarketingCommunicationsFlag: this.activateMarketingCommunicationsFlag,
          customerCreatedFlag: '',
          accountCreatedFlag: '',
          beneficiaryCreatedFlag: '',
        }),
        b2bSessionId: reviewMappingData.b2bSessionId,
      };
      this.consentAcceptedFlag = false;
      this.onBoardingConsentsAccepted = false;
      this.accountConsentsAccepted = false;
      localStorage.setItem('applicationNumber', reviewMappingData.applicationNumber);
      const additionalInfoData = await CommonService.finalSubmit(urlObj.finalSubmit, data, false);

      store.dispatch('userStore/setUserData', {
        additionalInfoData,
      });

      const status = additionalInfoData?.data?.status;

      if (![400, 403, 500].includes(status)) {
        store.dispatch('userStore/setUserData', { additionalInfoData });
        if (additionalInfoData != null && additionalInfoData !== '') {
          this.consentAcceptedFlag = false;
          this.onBoardingConsentsAccepted = false;
          this.accountConsentsAccepted = false;
          this.finalScreenData = additionalInfoData;
          this.$router.push({ params: { action: 'onboardStatus' } });
        }
      } else if (status === 500) {
        this.applicationDown = true;
        store.dispatch('appStore/setAppData', { inProgress: false });
        this.$router.push({ params: { action: 'onboardStatus' } });
      } else if ([400, 401, 403, 404, 413, 429].includes(status)) {
        store.dispatch('appStore/setAppData', { inProgress: false });
        this.consentAcceptedFlag = false;
        this.onBoardingConsentsAccepted = false;
        this.accountConsentsAccepted = false;
        this.$router.push({ params: { action: 'onboardStatus' } });
      }
    },
    checkPreFilledDataCount(keys, data) {
      return keys.filter((key) => !this.isValueValid(data[key])).length;
    },
    isValueValid(value) {
      return value !== null && value !== undefined && value !== '';
    },
    resetNominatedAccountData() {
      this.ibanValue = !!(this.accountInfoData.isIBANAvailable === true || this.accountInfoData.isIBANAvailable === 'true');
      this.bicCode = this.accountInfoData.bicCode;
      this.finalBankName = this.accountInfoData.bankName;
      this.finalCurrency = this.accountInfoData.currency;
      this.sortCodeFinal = this.accountInfoData.sortCode;
      this.accountNumber = this.accountInfoData.accountNumber;
    },
    async loadDropdowns() {
      const taxExemptionStatus = appSettings.dco?.taxExemptionReason ? appSettings.dco.taxExemptionReason : 'TAXEXEMPTIONSTATUS_P';
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const personalReviewData = JSON.parse(reviewMappingData.personalInformation);
      const otherInformation = JSON.parse(reviewMappingData.otherInformation);

      if (this.$appSettings && this.$appSettings?.dcoConfigurations.udfEnabled) {
        const sourceCountryOfFunds = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.sourceCountryOfFunds}`, { b2bSessionId: this.b2bSessionId }, false);
        const purposeOfAccount = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.purposeOfAccount}`, { b2bSessionId: this.b2bSessionId }, false);
        const expectedUsage = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.expectedUsage}`, { b2bSessionId: this.b2bSessionId }, false);
        const jobList = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.job}`, { b2bSessionId: this.b2bSessionId }, false);
        const udfBusinessTypeList = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.udfBusinessType}`, { b2bSessionId: this.b2bSessionId }, false);

        this.sourceCountryOfFunds = sourceCountryOfFunds?.data;
        this.purposeOfAccountDropdown = purposeOfAccount?.data;
        this.expectedUsageDropdown = expectedUsage.data;
        this.jobDropDown = jobList?.data;
        this.udfBusinessTypeDropdown = udfBusinessTypeList?.data;
      }

      if (otherInformation && otherInformation.employmentDetails !== null) {
        const employmentStatusList = await CommonService.getSalutationDropDown(urlObj.employmentStatus, { b2bSessionId: this.b2bSessionId });
        const employmentTypeList = await CommonService.getSalutationDropDown(urlObj.employmentType, { b2bSessionId: this.b2bSessionId });
        const businessTypeList = await CommonService.getSalutationDropDown(urlObj.businessType, { b2bSessionId: this.b2bSessionId });
        const jobTitleList = await CommonService.getSalutationDropDown(urlObj.jobTitle, { b2bSessionId: this.b2bSessionId });
        const paymentFrequencyList = await CommonService.getSalutationDropDown(urlObj.paymentFrequency, { b2bSessionId: this.b2bSessionId });
        const paymentMethodList = await CommonService.getSalutationDropDown(urlObj.paymentMethod, { b2bSessionId: this.b2bSessionId });

        this.employmentDetails.employmentStatusList = employmentStatusList.data;
        this.employmentDetails.employmentTypeList = employmentTypeList.data;
        this.employmentDetails.businessTypeList = businessTypeList.data;
        this.employmentDetails.jobTitleList = jobTitleList.data;
        this.employmentDetails.paymentFrequencyList = paymentFrequencyList.data;
        this.employmentDetails.paymentMethodList = paymentMethodList.data;
        this.employmentDetails.nameOfTheEmployer = otherInformation.employmentDetails?.nameOfTheEmployer;
      }
      const splitDateOfBirth = personalReviewData?.dateOfBirth.split('-');
      const yearsAllowed = this.$appSettings.dcoConfigurations.maximumAgeLimit[this.getProductType];
      const ageValidationCheck = otherInformation && otherInformation?.lisaTransferInWithAgeValidation !== undefined && otherInformation?.lisaTransferInWithAgeValidation !== null ? otherInformation?.lisaTransferInWithAgeValidation === true || otherInformation?.lisaTransferInWithAgeValidation === 'true' ? 'true' : 'false' : localStorage.getItem('isLisaTransferInWithAgeCheck') === 'true' ? 'true' : 'false';
      const yearData = this.getProductType === 'lifetimeISA' ? await CommonService.getYear(`${yearsAllowed}/${'LISA'}/${ageValidationCheck}`) : await CommonService.getYear(`${yearsAllowed}`);
      const monthData = this.getProductType === 'lifetimeISA' ? await CommonService.getMonth(`${yearsAllowed}/${splitDateOfBirth[0]}/${'LISA'}/${ageValidationCheck}`) : await CommonService.getMonth(`${yearsAllowed}/${splitDateOfBirth[0]}`);
      const dayData = this.getProductType === 'lifetimeISA' ? await CommonService.getDate(`${yearsAllowed}/${splitDateOfBirth[0]}/${splitDateOfBirth[1]}/${'LISA'}/${ageValidationCheck}`) : await CommonService.getDate(`${yearsAllowed}/${splitDateOfBirth[0]}/${splitDateOfBirth[1]}`);

      this.salutation = await CommonService.getSalutationDropDown(urlObj.salutation, { b2bSessionId: this.b2bSessionId });

      const rNationality = await CommonService.getSalutationDropDown(urlObj.nationality, { b2bSessionId: this.b2bSessionId });
      const rCountry = await CommonService.getSalutationDropDown(urlObj.country, { b2bSessionId: this.b2bSessionId });
      const nationalIdentities = await CommonService.getSalutationDropDown(urlObj.nationalIdentities, { b2bSessionId: this.b2bSessionId });
      const currency = await CommonService.getSalutationDropDown(urlObj.currency, { b2bSessionId: this.b2bSessionId });
      const relationshipType = await CommonService.getTaxExemptionDropDown(`${urlObj.relationshipType}/${'1062'}`, { b2bSessionId: this.b2bSessionId });
      const rTaxExemptionDropdown = await CommonService.getTaxExemptionDropDown(`${urlObj.taxExemption}/${taxExemptionStatus}?review`, { b2bSessionId: this.b2bSessionId });

      this.yearsDropdown = yearData.data;
      this.monthsDropdown = monthData.data;
      this.daysDropdown = dayData.data;
      this.reviewNationality = rNationality.data;
      this.reviewCountry = rCountry.data;
      this.corrCountry = this.reviewCountry;
      this.previousCountry = this.reviewCountry;
      this.nationalIdentities = nationalIdentities.data;
      this.reviewCurrency = currency.data;
      this.taxExemptionDropDown = rTaxExemptionDropdown?.data;
      this.items = this.salutation.data;
      this.relationshipTypeDropDown = relationshipType?.data;
    },
    async payload(editedSectionData, editedData) {
      if (editedSectionData === 'addressInformation') {
        if ((this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'true') && !this.addressAddedManually) {
          if (editedData?.primaryAddress?.addressID !== '' && this.mainAddressresponse === '' && this.isDefault === editedData.primaryAddress.isDefault) {
            this.primaryAddress = editedData.primaryAddress;
          } else if (this.mainAddressresponse === '' && this.isDefault !== editedData.primaryAddress.isDefault) {
            this.primaryAddress = {
              postCode: editedData?.primaryAddress?.postCode.split(' ').join('').toLowerCase(),
              addressID: editedData?.primaryAddress?.addressID || '',
              buildingNumber: '',
              addressLine1: editedData?.primaryAddress?.addressLine1 || '',
              addressLine2: editedData?.primaryAddress?.addressLine2 || '',
              addressLine3: editedData?.primaryAddress?.addressLine3 || '',
              addressLine4: editedData?.primaryAddress?.addressLine4 || '',
              addressLine5: editedData?.primaryAddress?.addressLine5 || '',
              addressLine6: editedData?.primaryAddress?.addressLine6 || '',
              addressLine7: editedData?.primaryAddress?.addressLine7 || '',
              addressLine8: editedData?.primaryAddress?.addressLine8 || '',
              addressLine9: editedData?.primaryAddress?.addressLine9 || '',
              addressLine10: editedData?.primaryAddress?.addressLine10 || '',
              addressText: this.residentialAddress || '',
              city: editedData?.primaryAddress?.city,
              stateOrprovince: editedData?.primaryAddress?.stateOrprovince || '',
              stateOrprovinceName: editedData?.primaryAddress?.stateOrprovince || '',
              country: editedData?.primaryAddress?.country,
              isDefault: (this.isDefault === true),
            };
          } else {
            this.primaryAddress = {
              postCode: this.mainAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
              addressID: this.mainAddressresponse.data?.addressId || '',
              buildingNumber: '',
              addressLine1: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine1 || ''),
              addressLine2: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine2 || ''),
              addressLine3: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine3 || ''),
              addressLine4: this.decodeHtmlEntities(this.mainAddressresponse.data?.addressLine4 || ''),
              addressLine5: this.mainAddressresponse.data?.addressLine5 || '',
              addressLine6: this.mainAddressresponse.data?.addressLine6 || '',
              addressLine7: this.mainAddressresponse.data?.addressLine7 || '',
              addressLine8: this.mainAddressresponse.data?.addressLine8 || '',
              addressLine9: this.mainAddressresponse.data?.addressLine9 || '',
              addressLine10: this.mainAddressresponse.data?.addressLine10 || '',
              addressText: this.residentialAddress || '',
              city: this.mainAddressresponse.data.city,
              stateOrprovince: this.mainAddressresponse.data?.region || '',
              stateOrprovinceName: this.mainAddressresponse.data?.region || '',
              country: this.mainAddressresponse.data.countryCode,
              isDefault: (this.isDefault === true),
            };
          }
          if (this.reviewCorresponding === true) {
            this.correspondingAddress = {
              postCode: this.primaryAddress.postCode.split(' ').join('').toLowerCase(),
              addressID: this.primaryAddress?.addressID || '',
              buildingNumber: '',
              addressLine1: this.primaryAddress?.addressLine1 || '',
              addressLine2: this.primaryAddress?.addressLine2 || '',
              addressLine3: this.primaryAddress?.addressLine3 || '',
              addressLine4: this.primaryAddress?.addressLine4 || '',
              addressLine5: this.primaryAddress?.addressLine5 || '',
              addressLine6: this.primaryAddress?.addressLine6 || '',
              addressLine7: this.primaryAddress?.addressLine7 || '',
              addressLine8: this.primaryAddress?.addressLine8 || '',
              addressLine9: this.primaryAddress?.addressLine9 || '',
              addressLine10: this.primaryAddress?.addressLine10 || '',
              addressText: this.residentialAddress || '',
              city: this.primaryAddress?.city,
              stateOrprovince: this.primaryAddress?.stateOrprovince || '',
              stateOrprovinceName: this.primaryAddress?.stateOrprovince || '',
              country: this.primaryAddress?.country,
              isDefault: (this.isDefault === false),
            };
            this.correspondenceAddress = '';
            this.corrAddressresponse = '';
          } else if ((this.reviewCorresponding === false)) {
            if (editedData?.correspondenceAddress?.addressID !== '' && this.corrAddressresponse === '') {
              this.correspondingAddress = {
                postCode: editedData?.correspondenceAddress?.postCode.split(' ').join('').toLowerCase(),
                addressID: editedData?.correspondenceAddress?.addressID,
                buildingNumber: null,
                addressLine1: editedData?.correspondenceAddress?.addressLine1 || '',
                addressLine2: editedData?.correspondenceAddress?.addressLine2 || '',
                addressLine3: editedData?.correspondenceAddress?.addressLine3 || '',
                addressLine4: editedData?.correspondenceAddress?.addressLine4 || '',
                addressLine5: editedData?.correspondenceAddress?.addressLine5 || '',
                addressLine6: editedData?.correspondenceAddress?.addressLine6 || '',
                addressLine7: editedData?.correspondenceAddress?.addressLine7 || '',
                addressLine8: editedData?.correspondenceAddress?.addressLine8 || '',
                addressLine9: editedData?.correspondenceAddress?.addressLine9 || '',
                addressLine10: editedData?.correspondenceAddress?.addressLine10 || '',
                addressText: editedData?.correspondenceAddress?.addressText || '',
                city: editedData?.correspondenceAddress?.city,
                stateOrprovince: editedData?.correspondenceAddress?.stateOrprovince || '',
                stateOrprovinceName: editedData?.correspondenceAddress?.stateOrprovince || '',
                country: editedData?.correspondenceAddress?.country,
                isDefault: (this.isDefault === false),
              };
            } else {
              this.correspondingAddress = {
                postCode: this.corrAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                addressID: this.corrAddressresponse.data?.addressId,
                buildingNumber: null,
                addressLine1: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine1 || ''),
                addressLine2: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine2 || ''),
                addressLine3: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine3 || ''),
                addressLine4: this.decodeHtmlEntities(this.corrAddressresponse.data?.addressLine4 || ''),
                addressLine5: this.corrAddressresponse.data?.addressLine5 || '',
                addressLine6: this.corrAddressresponse.data?.addressLine6 || '',
                addressLine7: this.corrAddressresponse.data?.addressLine7 || '',
                addressLine8: this.corrAddressresponse.data?.addressLine8 || '',
                addressLine9: this.corrAddressresponse.data?.addressLine9 || '',
                addressLine10: this.corrAddressresponse.data?.addressLine10 || '',
                addressText: this.correspondenceAddress || '',
                city: this.corrAddressresponse.data?.city,
                stateOrprovince: this.corrAddressresponse.data?.region || '',
                stateOrprovinceName: this.corrAddressresponse.data?.region || '',
                country: this.corrAddressresponse.data.countryCode,
                isDefault: (this.isDefault === false),
              };
            }
          }
          if (this.selected === false) {
            if (editedData?.previousResidentialAddress?.addressID !== '' && this.prevAddressresponse === '') {
              this.previousResidentialAddress = {
                postCode: editedData?.previousResidentialAddress?.postCode.split(' ').join('').toLowerCase(),
                addressID: editedData?.previousResidentialAddress?.addressID || '',
                buildingNumber: null,
                addressLine1: editedData?.previousResidentialAddress?.addressLine1 || '',
                addressLine2: editedData?.previousResidentialAddress?.addressLine2 || '',
                addressLine3: editedData?.previousResidentialAddress?.addressLine3 || '',
                addressLine4: editedData?.previousResidentialAddress?.addressLine4 || '',
                addressLine5: editedData?.previousResidentialAddress?.addressLine5 || '',
                addressLine6: editedData?.previousResidentialAddress?.addressLine6 || '',
                addressLine7: editedData?.previousResidentialAddress?.addressLine7 || '',
                addressLine8: editedData?.previousResidentialAddress?.addressLine8 || '',
                addressLine9: editedData?.previousResidentialAddress?.addressLine9 || '',
                addressLine10: editedData?.previousResidentialAddress?.addressLine10 || '',
                addressText: editedData?.previousResidentialAddress?.addressText || '',
                city: editedData?.previousResidentialAddress?.city,
                stateOrprovince: editedData?.previousResidentialAddress?.stateOrprovince || '',
                stateOrprovinceName: editedData?.previousResidentialAddress?.stateOrprovince || '',
                country: editedData?.previousResidentialAddress?.country,
                fromDate: editedData?.previousResidentialAddress?.fromDate,
                toDate: editedData?.previousResidentialAddress?.toDate,
              };
            } else {
              this.previousResidentialAddress = {
                postCode: this.prevAddressresponse.data.postCode.split(' ').join('').toLowerCase(),
                addressID: this.prevAddressresponse.data?.addressId,
                buildingNumber: null,
                addressLine1: this.prevAddressresponse.data?.addressLine1 || '',
                addressLine2: this.prevAddressresponse.data?.addressLine2 || '',
                addressLine3: this.prevAddressresponse.data?.addressLine3 || '',
                addressLine4: this.prevAddressresponse.data?.addressLine4 || '',
                addressLine5: this.prevAddressresponse.data?.addressLine5 || '',
                addressLine6: this.prevAddressresponse.data?.addressLine6 || '',
                addressLine7: this.prevAddressresponse.data?.addressLine7 || '',
                addressLine8: this.prevAddressresponse.data?.addressLine8 || '',
                addressLine9: this.prevAddressresponse.data?.addressLine9 || '',
                addressLine10: this.prevAddressresponse.data?.addressLine10 || '',
                addressText: this.previousResidentialAddress || '',
                city: this.prevAddressresponse.data?.city,
                stateOrprovince: this.prevAddressresponse.data?.region || '',
                stateOrprovinceName: this.prevAddressresponse.data?.region || '',
                country: this.prevAddressresponse.data.countryCode,
                fromDate: this.fromDate,
                toDate: this.toDate,
              };
            }
          } else if (this.selected === true) {
            this.previousResidentialAddress = '';
            this.prevAddressresponse = '';
            this.fromDate = '';
            this.toDate = '';
          }
        } else if (!this.isAddressLookupEnabled || this.isAddressLookupEnabled === 'false' || this.addressAddedManually) {
          this.primaryAddress = {
            postCode: this.formData.primaryAddress.postCode,
            addressID: '',
            buildingNumber: '',
            addressLine1: this.formData.primaryAddress.addressLine1,
            addressLine2: this.formData.primaryAddress.addressLine2 || '',
            addressLine3: this.addPrimaryAddressLine3 ? this.formData.primaryAddress.addressLine3 : '',
            addressLine4: this.addPrimaryAddressLine4 ? this.formData.primaryAddress.addressLine4 : '',
            city: this.formData.primaryAddress.city,
            stateOrprovince: this.formData.primaryAddress.stateOrprovince,
            country: this.formData.primaryAddress.country,
            stateOrprovinceName: this.formData?.primaryStateDescription ?? editedData?.primaryAddress?.stateOrprovinceName,
            countryName: this.isValueValid(this.formData?.primaryCountryDescription) ? this.formData?.primaryCountryDescription : editedData?.primaryAddress?.countryName,
            isDefault: (this.isDefaultManual === true),
          };
          if (this.manualInputCorresponding === true) {
            this.correspondingAddress = {
              postCode: this.formData.primaryAddress.postCode,
              addressID: '',
              buildingNumber: '',
              addressLine1: this.formData.primaryAddress.addressLine1,
              addressLine2: this.formData.primaryAddress.addressLine2 || '',
              addressLine3: this.addPrimaryAddressLine3 ? this.formData.primaryAddress.addressLine3 : '',
              addressLine4: this.addPrimaryAddressLine3 && this.addPrimaryAddressLine4 ? this.formData.primaryAddress.addressLine4 : '',
              city: this.formData.primaryAddress.city,
              stateOrprovince: this.formData.primaryAddress.stateOrprovince,
              stateOrprovinceName: this.formData?.primaryStateDescription ?? editedData?.primaryAddress?.stateOrprovinceName,
              countryName: this.isValueValid(this.formData?.primaryCountryDescription) ? this.formData?.primaryCountryDescription : editedData?.primaryAddress?.countryName,
              country: this.formData.primaryAddress.country,
              isDefault: (this.isDefaultManual === false),
            };
          } else if (this.manualInputCorresponding === false) {
            this.correspondingAddress = {
              postCode: this.formData.correspondenceAddress.postCode,
              addressID: '',
              buildingNumber: '',
              addressLine1: this.formData.correspondenceAddress.addressLine1,
              addressLine2: this.formData.correspondenceAddress.addressLine2 || '',
              addressLine3: this.addcorrAddressLine3 ? this.formData.correspondenceAddress.addressLine3 : '',
              addressLine4: this.addcorrAddressLine3 && this.addcorrAddressLine4 ? this.formData.correspondenceAddress.addressLine4 : '',
              city: this.formData.correspondenceAddress.city,
              stateOrprovince: this.formData.correspondenceAddress.stateOrprovince,
              country: this.formData.correspondenceAddress.country,
              stateOrprovinceName: this.formData?.correspondenceStateDescription ?? editedData?.correspondenceAddress?.stateOrprovinceName,
              countryName: this.isValueValid(this.formData?.correspondenceCountryDescription) ? this.formData?.correspondenceCountryDescription : editedData?.correspondenceAddress?.countryName,
              isDefault: (this.isDefaultManual === false),
            };
          }
          if (this.prevManualAddress === false) {
            this.previousResidentialAddress = {
              postCode: this.formData.previousResidentialAddress.postCode,
              addressID: '',
              buildingNumber: '',
              addressLine1: this.formData.previousResidentialAddress.addressLine1,
              addressLine2: this.formData.previousResidentialAddress.addressLine2,
              addressLine3: this.addprevAddressLine3 ? this.formData.previousResidentialAddress.addressLine3 : '',
              addressLine4: this.addprevAddressLine3 && this.addprevAddressLine4 ? this.formData.previousResidentialAddress.addressLine4 : '',
              city: this.formData.previousResidentialAddress.city,
              stateOrprovince: this.formData.previousResidentialAddress.stateOrprovince,
              country: this.formData.previousResidentialAddress.country,
              stateOrprovinceName: this.formData?.previousStateDescription ?? editedData?.previousResidentialAddress?.stateOrprovinceName,
              countryName: this.isValueValid(this.formData?.previousCountryDescription) ? this.formData?.previousCountryDescription : editedData?.previousResidentialAddress?.countryName,
              fromDate: this.formData.previousResidentialAddress.fromDate || this.fromDate,
              toDate: this.formData.previousResidentialAddress.toDate || this.toDate,
            };
          }
        }
        const contactInformation = (this.isAddressLookupEnabled === 'true' && !this.addressAddedManually && this.selected === false) || (this.addressAddedManually && this.prevManualAddress === false)
          ? JSON.stringify({ primaryAddress: this.primaryAddress, correspondenceAddress: this.correspondingAddress, previousResidentialAddress: this.previousResidentialAddress,
          }) : this.correspondingAddress !== '' && this.correspondingAddress !== null ? JSON.stringify({
            primaryAddress: this.primaryAddress,
            correspondenceAddress: this.correspondingAddress,
          }) : JSON.stringify({ primaryAddress: this.primaryAddress });

        return contactInformation;
      } else if (editedSectionData === 'personalInformation' || editedSectionData === 'complianceInformation') {
        const isPersonalInformation = editedSectionData === 'personalInformation';

        const personalInformation = {
          titleCode: isPersonalInformation ? this.formData.titleCode : editedData?.titleCode,
          titleDescription: isPersonalInformation ? this.formData.titleDescription : editedData?.titleDescription,
          firstName: isPersonalInformation ? this.formData.firstName : editedData?.firstName,
          middleName: isPersonalInformation ? this.reviewMiddleNameCheckbox ? this.formData.middleName : '' : editedData?.middleName,
          lastName: isPersonalInformation ? this.formData.lastName : editedData?.lastName,
          gender: isPersonalInformation ? this.formData.gender : editedData?.gender,
          dateOfBirth: isPersonalInformation ? this.formData.year + '-' + this.formData.month + '-' + this.formData.date : editedData?.dateOfBirth,
          nationalIdTypeId: isPersonalInformation ? this.formData.nationalIdTypeId : editedData?.nationalIdTypeId,
          nationalIdTypeCode: isPersonalInformation ? this.formData?.nationalIdTypeCode : editedData?.nationalIdTypeCode,
          nationalIdNumber: isPersonalInformation ? this.formData.nationalIdNumber : editedData?.nationalIdNumber,
          residentCountryId: editedData?.residentCountryId,
          residentCountryCode: editedData?.residentCountryCode,
          birthCountryCode: isPersonalInformation ? this.formData.birthCountryCode : editedData?.birthCountryCode,
          birthCountryName: isPersonalInformation ? this.formData.birthCountryDescription : editedData?.birthCountryDescription,
          areYouAUKResident: isPersonalInformation ? 'true' : editedData?.areYouAUKResident,
          primaryNationality: isPersonalInformation ? this.formData.primaryNationality : editedData?.primaryNationality,
          primaryNationalityDescription: isPersonalInformation ? this.formData.primaryNationalityDescription : editedData?.primaryNationalityDescription,
          secondaryNationality: isPersonalInformation ? this.formData?.secondaryNationality : editedData?.secondaryNationality || '',
          preferredLanguageName: '',
          preferredLanguageCode: this.localeSelected,
          sourceCountryOfFunds: isPersonalInformation ? editedData?.sourceCountryOfFunds : this.formData?.sourceCountryOfFunds !== undefined && this.formData?.sourceCountryOfFunds !== '' ? this.formData?.sourceCountryOfFunds : editedData?.sourceCountryOfFunds,
          expectedTurnover: isPersonalInformation ? editedData?.expectedTurnover : this.formData?.expectedTurnover,
          sourceCountryOfFundsDescription: isPersonalInformation ? editedData?.sourceCountryOfFundsDescription : this.formData?.sourceCountryOfFundsDescription !== undefined && this.formData?.sourceCountryOfFundsDescription !== '' ? this.formData?.sourceCountryOfFundsDescription : editedData?.sourceCountryOfFundsDescription,
          job: isPersonalInformation ? editedData?.job : this.formData?.job !== undefined && this.formData?.job !== '' ? this.formData?.job : editedData?.job,
          jobDescription: isPersonalInformation ? editedData?.jobDescription : this.formData?.jobDescription !== undefined && this.formData?.jobDescription !== '' ? this.formData?.jobDescription : editedData?.jobDescription,
          udfBusinessType: isPersonalInformation ? editedData?.udfBusinessType : this.formData?.udfBusinessType !== undefined && this.formData?.udfBusinessType !== '' ? this.formData?.udfBusinessType : editedData?.job,
          udfBusinessTypeDescription: isPersonalInformation ? editedData?.udfBusinessTypeDescription : this.formData?.udfBusinessTypeDescription !== undefined && this.formData?.udfBusinessTypeDescription !== '' ? this.formData?.udfBusinessTypeDescription : editedData?.udfBusinessTypeDescription,
        };
        return personalInformation;
      } else if (editedSectionData === 'accountInformation') {
        if (this.ibanValue === true) {
          this.accountInformation = !this.isValueValid(this.ibanNumber) && !this.isValueValid(this.bicCode) ? null : JSON.stringify({
            isIBANAvailable: 'true',
            iban: this.ibanNumber || '',
            bicCode: this.bicCode || '',
            bankName: this.finalBankName || '',
            currency: this.finalCurrency || '',
            sortCode: '',
            accountNumber: '',
            accountVerifiedFlag: true,
            postingRestriction: '',
          });
        } else if (this.ibanValue === false) {
          this.accountInformation = !this.isValueValid(this.accountNumber) && !this.isValueValid(this.sortCodeFinal) ? null : JSON.stringify({
            isIBANAvailable: 'false',
            iban: '',
            bicCode: '',
            bankName: this.finalBankName || '',
            currency: this.finalCurrency || '',
            sortCode: this.sortCodeFinal || '',
            accountNumber: this.accountNumber || '',
            accountVerifiedFlag: true,
            postingRestriction: '',
          });
          // const verifyAccount = (this.accountNumber && this.sortCodeFinal) ? await CommonService.verifyAccount(urlObj.verifyAccount, {
          //   sortCode: this.sortCodeFinal,
          //   accountNumber: this.accountNumber,
          //   title: this.formData?.titleCode || '',
          //   firstName: this.formData.firstName,
          //   lastName: this.formData?.lastName || '',
          //   dateOfBirth: this.formData?.dateOfBirth,
          //   addressId: this.primaryAddress?.addressID || '',
          //   addressLine1: this.primaryAddress?.addressLine1 || this.formData.primaryAddress.addressLine1,
          //   addressLine2: this.primaryAddress?.addressLine2 || this.formData.primaryAddress.addressLine2,
          //   addressLine3: this.primaryAddress?.addressLine3 || this.formData.primaryAddress.addressLine3,
          //   addressLine4: this.primaryAddress?.addressLine4 || this.formData.primaryAddress.addressLine4,
          //   addressLine5: this.primaryAddress?.addressLine5 || '',
          //   addressLine6: this.primaryAddress?.addressLine6 || '',
          //   addressLine7: this.primaryAddress?.addressLine7 || '',
          //   addressLine8: this.primaryAddress?.addressLine8 || '',
          //   addressLine9: this.primaryAddress?.addressLine9 || '',
          //   postalCode: this.primaryAddress?.postCode.split(' ').join('').toLowerCase() || this.formData?.primaryAddress?.postCode,
          //   townOrCity: this.primaryAddress?.city || this.formData?.primaryAddress?.city || '',
          //   stateOrProvince: this.primaryAddress?.stateOrprovince || this.formData.primaryAddress.stateOrprovince || '',
          //   countryCode: this.primaryAddress?.country || this.formData.primaryAddress.country,
          // }) : '';
          // if (verifyAccount.externalBankAccountVerification === true) {
          //   this.accountInformation = this.accountNumber !== '' ? JSON.stringify({
          //     isIBANAvailable: 'false',
          //     iban: '',
          //     bicCode: '',
          //     bankName: this.finalBankName || '',
          //     currency: this.finalCurrency || '',
          //     sortCode: this.sortCodeFinal || '',
          //     accountNumber: this.accountNumber || '',
          //     accountVerifiedFlag: verifyAccount?.externalBankAccountVerification,
          //     postingRestriction: '',
          //   }) : null;
          // }
        } else {
          this.accountInformation = null;
        }
        return this.accountInformation;
      } else if (editedSectionData === 'taxInformation') {
        const taxInformation = {
          taxPayerFlag: this.taxValue,
          countryOfTaxResidentCode: this.formData.countryOfTaxResidentCode || 'GBR',
          countryOfTaxResidentName: this.formData.countryOfTaxResidenceDescription || 'United Kingdom',
          taxIdentificationNumber: this.taxValue ? this.formData.taxIdentificationNumber : '',
          taxExemptionReason: this.taxValue === false ? this.formData.taxExemptionReason : '',
          taxExemptionReasonName: this.taxValue === false ? this.formData.taxExemptionDescription : '',
          taxResidentInOtherCountry: this.taxValue ? this.taxResidentInOtherCountry : '',
          foreignCountryOfTaxResidence: this.taxResidentInOtherCountry ? this.formData.foreignCountryOfTaxResidence : '',
          foreignCountryOfTaxResidenceName: this.formData.foreignCountryOfTaxResidenceDescription,
          tinNumberInOtherCountry: this.taxResidentInOtherCountry ? this.formData.tinNumberInOtherCountry : '',
          areYouUSResident: this.taxResidentInOtherCountry ? this.areYouUSResident : false,
        };

        return taxInformation;
      }
    },

  },
};

export default reviewInformationDataMixin;
